import React, { useEffect, useState } from "react";
import "./asset-management.css";
import "../assets/css/main.css";
import { AppSettings } from "../../constant";
import Select from "react-dropdown-select";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ViewDetail from "../view-detail/view-detail";
import History from "../history/history";
import AllcoateAsset from "../allocate-asset/allocate-asset";
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
// import Tooltip from 'react-bootstrap/Tooltip';
import Tooltip from "@mui/material/Tooltip";
import ExcelExportButton from "../excel-export/ExcelExportButton";
import axiosInstance from "../../axios-interceptor";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import eWasteIcon from "../assets/images/e-waste.svg";
import NoDataFoundImage from "../assets/images/no-data-found.svg";
import { getEwasteAssetList, moveToEwaste, updateEwasteStatus, eWasteStatus, createEwasteRequest } from "../../services/ewaste-service";

function AssetManagement() {
  const [currentAsset, setCurrentAsset] = useState(
    localStorage.getItem("currentAsset")
      ? localStorage.getItem("currentAsset")
      : "Desktop"
  );
  const customId = "custom-id-yes";
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [sidebarAction, setSidebarAction] = useState("");
  const [inputValues, setInputValues] = useState({});
  const [editItemId, setEditItemId] = useState(null);
  const [dropdownOptions, setDropdownOptions] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [addProp, setAddProp] = useState([]);
  const [ewasteStatusList, setEwasteStatusList] = useState([]);
  const [ewasteData, setEwasteData] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [filterValue, setFilterValue] = useState({
    state: { value: "All", label: "All" },
    brandId: { value: null, label: "Processor" },
    processorTypeID: { value: null, label: "Type" },
    generationId: { value: null, label: "Generation" },
    eWasteStatus: { value: 0, label: "All" },
  });
  const userData = JSON.parse(localStorage.getItem("userdata") || "{}");
  const isAdmin = userData?.rolename === "Admin";
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [activeToggle, setActiveToggle] = useState("Operational");
  const [dataError, setDataError] = useState({
    //network and other assets
    assetType: false,
    diskName: false,
    networkPort: false,
    imei: false,
    location: false,
    model: false,
    wiredStatus: false,
    os: false,
    //
    // biosVersion: false,
    brand: false,
    generation: false,
    // macId: false,
    brandId: false,
    processorTypeId: false,
    generationId: false,
    // purchaseDate: false,
    ram: false,
    serialNo: false,
    systemId: false,
    modelNo: false,
    storageSize: false,
    graphicCard: false,
    storageType: false,
    windowsOS: false,
    // warrantyTill: false,
    isAssigned: false,
    // isActive: false,
    // createdBy: false,
    // createdOn: false,
    // isMonitor: false,
    //isKeyboard: false,
    dimension: false,
    //isMouse: false,
    //isHeadSet: false,
    isAVInstalled: false,
    windowsLicense: false,
    isLicensed: false,
    isActive: false,
    ipAddress: false,
    // remarks: false,
    screensize: false,
    isWarrantyTill: false,
    purchaseDate: false,
  });

  const CAPITALIZE_SINGLE_SPACE_FIELDS = {
    serialNo: 50,
    brand: 50,
    modelNo: 50,
    macId: 50,
    dimension: 20,
    biosVersion: 50,
    generation: 10,
    ipAddress: 50,
    remarks: 250,
    screensize: 50,
    model: 50,
    diskName: 50,
    os: 50,
    networkPort: 50,
    location: 50,
  };

  function formatCapitalizedInput(val, maxLen) {
    if (val.length > 0) {
      val = val.charAt(0).toUpperCase() + val.slice(1);
    }
    val = val.replace(/ {2,}/g, " ");
    return maxLen ? val.slice(0, maxLen) : val;
  }

  const getTomorrowDateString = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  };

  const getTodayDateString = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [selectedValue, setSelectedValue] = useState({
    //network and other asset
    assetType: { value: null, label: "" },
    diskName: { value: null, label: "" },
    networkPort: { value: null, label: "" },
    imei: { value: null, label: "" },
    location: { value: null, label: "" },
    model: { value: null, label: "" },
    wiredStatus: { value: null, label: "Wired status" },
    os: { value: null, label: "" },
    //
    serialNo: { value: null, label: "" },
    systemId: { value: null, label: "" },
    modelNo: { value: null, label: "" },
    macId: { value: null, label: "" },
    biosVersion: { value: null, label: "" },
    brand: { value: null, label: "" },
    ram: { value: null, label: "" },
    brandId: { value: null, label: "" },
    processorTypeId: { value: null, label: "" },
    generationId: { value: null, label: "" },
    generation: { value: null, label: "" },
    storageType: { value: null, label: "Storage Type" },
    windowsOS: { value: null, label: "Os Type" },
    storageSize: { value: null, label: "" },
    graphicCard: { value: null, label: "" },
    screensize: { value: null, label: "" },
    purchaseDate: { value: null, label: "" },
    isWarrantyTill: { value: null, label: "" },
    warrantyTill: { value: null, label: " " },
    // isActive: { value: null, label: "Is Active" },
    // createdBy: { value: null, label: "" },
    createdOn: { value: null, label: "" },
    // isMonitor: { value: null, label: "is Monitor" },
    // isKeyboard: { value: null, label: "Keyboard" },
    dimension: { value: null, label: "" },
    //isMouse: { value: null, label: "Mouse" },
    // isHeadSet: { value: null, label: "HeadSet" },
    isAVInstalled: { value: null, label: "AVInstalled" },
    isLicensed: {
      value: null,
      label:
        inputValues?.windowsOS === "Mac Os" ||
          inputValues?.windowsOS === "Windows" ||
          inputValues?.windowsOS === undefined ||
          inputValues?.windowsOS === null ||
          ""
          ? "Licensed/Not"
          : "License Type",
    },
    windowsLicense: { value: null, label: "" },
    isActive: { value: null, label: "State" },
    remarks: { value: null, label: "" },
    ipAddress: { value: null, label: "" },
  });
  const [searchFilter, setSearchFilter] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);


  // const [filterValue, setFilterValue] = useState({
  //   state: { value: "All", label: "All" },
  //   brandId: { value: null, label: "Processor" },
  //   processorTypeID: { value: null, label: "Type" },
  //   generationId: { value: null, label: "Generation" },
  //   eWasteStatus: { value: 0, label: "All" },
  // });

  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };

  // const handleSelectAll = () => {
  //   const inCompanyIds = displayedData
  //     .filter((d) => d.eWasteStatus === 1)
  //     .map((d) => d.id);
  //   if (selectedRows.length === inCompanyIds.length && inCompanyIds.length > 0) {
  //     setSelectedRows([]);
  //   } else {
  //     setSelectedRows(inCompanyIds);
  //   }
  // };
  const handleSelectAll = () => {
    const selectableIds =
      activeToggle === "ewaste"
        ? displayedData.filter((d) => d.eWasteStatus === 1).map((d) => d.id)
        : displayedData.filter((d) => !d.assignedTo && d.eWasteStatus !== 0).map((d) => d.id);
    if (selectedRows.length === selectableIds.length && selectableIds.length > 0) {
      setSelectedRows([]);
    } else {
      setSelectedRows(selectableIds);
    }
  };

  const handleDispose = async () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one asset", { toastId: customId });
      return;
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body" style={{ position: "relative" }}>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "32px",
                height: "32px",
                background: "transparent",
                border: "none",
                fontSize: "28px",
                fontWeight: "400",
                lineHeight: "1",
                cursor: "pointer",
                color: "#6c757d",
                opacity: 0.8,
                padding: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.8")}
            >
              ×
            </button>
            <h1>Dispose Assets</h1>
            {`Are you sure you want to dispose ${selectedRows.length} asset(s)?`}
            <div className="react-confirm-alert-button-group">
              <button
                onClick={onClose}
              >
                No
              </button>
              <button
                onClick={async () => {
                  try {
                    const param = assetTypeParamMap[currentAsset] || currentAsset.toLowerCase();
                    await updateEwasteStatus(selectedRows, param, 2);
                    toast.success("Assets disposed successfully", { toastId: customId });
                    setSelectedRows([]);
                    fetchEWasteData(currentAsset);
                  } catch (err) {
                    toast.error("Something went wrong", { toastId: customId });
                  }
                  onClose();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };

  // const handleAssetClick = (event) => {
  //   setSelectedRows([]);
  //   clearFilter();
  //   setData([]);
  //   setFilteredData([]);
  //   if (event !== currentAsset) {
  //     fetchData(event);
  //   }
  //   setSearchFilter("");
  //   setCurrentAsset(event);
  //   localStorage.setItem("currentAsset", event);
  //   if (event === "Network") {
  //     fetchDropdownOptions("Network/GetAllNetworkAssetTypeMaster");
  //   } else if (event === "OtherAsset") {
  //     fetchDropdownOptions("OtherAsset/GetAllOtherAssetTypeMaster");
  //   } else if (event === "Desktop" || event === "Laptop") {
  //     fetchDropdownOptions("Master/GetProcessorType");
  //   }
  //   setCurrentPage(1);
  //   setActiveToggle("Operational");
  // };

  const handleAssetClick = (event) => {
    setSelectedRows([]);
    clearFilter();
    setData([]);
    setFilteredData([]);
    setLoading(false);
    if (event !== currentAsset) {
      fetchData(event);
    }
    setSearchFilter("");
    setCurrentAsset(event);
    localStorage.setItem("currentAsset", event);
    if (event === "Network") {
      fetchDropdownOptions("Network/GetAllNetworkAssetTypeMaster");
    } else if (event === "OtherAsset") {
      fetchDropdownOptions("OtherAsset/GetAllOtherAssetTypeMaster");
    } else if (event === "Desktop" || event === "Laptop" || event === "RentalLaptop") {
      fetchDropdownOptions("Master/GetProcessorType");
    }
    setCurrentPage(1);
    setActiveToggle("Operational");
  };

  const assetTypeParamMap = {
    Desktop: "desktop",
    Laptop: "laptop",
    Monitor: "monitor",
    Network: "network",
    OtherAsset: "otherassets",
    RentalLaptop: "rentallaptop",
  };

  // const fetchEWasteData = async (asset) => {
  //   try {
  //     setLoading(false);
  //     const param = assetTypeParamMap[asset] || asset.toLowerCase();
  //     const assets = await getEwasteAssetList(param);
  //     setFilteredData(assets);
  //     setLoading(true);
  //   } catch (err) {
  //     console.log(err.message);
  //     setLoading(true);
  //   }
  // };
  const fetchEWasteData = async (asset, filter) => {
    try {
      setLoading(false);
      const param = assetTypeParamMap[asset] || asset.toLowerCase();
      const payload = {
        assetType: param,
        ...(filter?.eWasteStatus && filter.eWasteStatus !== 0 && { eWasteStatus: filter.eWasteStatus }),
        ...(filter?.brandId && { brandId: filter.brandId }),
        ...(filter?.processorTypeID && { processorTypeID: filter.processorTypeID }),
        ...(filter?.generationId && { generationId: filter.generationId }),
      };
      const result = await getEwasteAssetList(payload);
      const list = result?.response?.assets ?? result?.assets ?? result;
      const safeList = Array.isArray(list) ? list : [];
      setEwasteData(safeList);
      setFilteredData(safeList);
      setLoading(true);
    } catch (err) {
      console.log(err.message);
      setLoading(true);
    }
  };
  const fetchEwasteStatuses = async () => {
    const statuses = await eWasteStatus();
    return statuses;
  };
  // const handleMoveToEwaste = async (item) => {
  //   confirmAlert({
  //     title: "Move to E-Waste",
  //     message: `Are you sure you want to move ${item.systemId} to E-Waste?`,
  //     buttons: [
  //       {
  //         label: "Yes",
  //         onClick: async () => {
  //           try {
  //             const param = assetTypeParamMap[currentAsset] || currentAsset.toLowerCase();
  //             await moveToEwaste(item.id, param); // still passes single id, service wraps it
  //             toast.success("Moved to E-Waste successfully", { toastId: customId });
  //             fetchData(currentAsset);
  //           } catch (err) {
  //             toast.error("Something went wrong", { toastId: customId });
  //           }
  //         },
  //       },
  //       { label: "No" },
  //     ],
  //   });
  // };
  const handleMoveSelectedToEwaste = () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one asset", { toastId: customId });
      return;
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body" style={{ position: "relative" }}>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "32px",
                height: "32px",
                background: "transparent",
                border: "none",
                fontSize: "28px",
                fontWeight: "400",
                lineHeight: "1",
                cursor: "pointer",
                color: "#6c757d",
                opacity: 0.8,
                padding: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.8")}
            >
              ×
            </button>
            <h1>Move to E-Waste</h1>
            {`Are you sure you want to move ${selectedRows.length} asset(s) to E-Waste?`}
            <div className="react-confirm-alert-button-group">
              <button
                onClick={onClose}
              >
                No
              </button>
              <button
                onClick={async () => {
                  try {
                    const param = assetTypeParamMap[currentAsset] || currentAsset.toLowerCase();
                    const res = await createEwasteRequest(selectedRows, param, userData?.rolename);
                    toast.success(res?.message || "EWaste request submitted successfully", { toastId: customId });
                    setSelectedRows([]);
                    fetchData(currentAsset);
                  } catch (err) {
                    toast.error("Something went wrong", { toastId: customId });
                  }
                  onClose();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };
  useEffect(() => {
    fetchData(currentAsset);
    handleAssetClick(currentAsset);

    fetchEwasteStatuses().then(setEwasteStatusList).catch(console.error);
  }, []);
  const clearFilter = () => {
    setFilterValue({
      state: { value: "All", label: "All" },
      brandId: { value: null, label: "Processor" },
      processorTypeID: { value: null, label: "Type" },
      generationId: { value: null, label: "Generation" },
      eWasteStatus: { value: 0, label: "All" },
    });
  };

  const fetchData = async (event, filter) => {
    try {
      const params = {};

      if (filter?.brandId) params.brandId = filter.brandId;
      if (filter?.processorTypeID) params.processorTypeID = filter.processorTypeID;
      if (filter?.generationId) params.generationId = filter.generationId;

      if (filter?.isActive !== undefined && filter?.isActive !== "All") {
        params.isActive = filter.isActive;
      }

      const res = await axiosInstance.get(
        AppSettings.URLs.asset + event + "/GetAllActive" + event + "sAsync",
        { params }
      );

      let list = [];
      if (res != null) {
        if (event === "OtherAsset") {
          list = res?.data?.response?.[event.split("Other")[1].toLowerCase() + "s"] || [];
        } else if (event === "RentalLaptop") {
          list = res?.data?.response?.rentalLaptops || [];
        } else {
          list = res?.data?.response?.[event.toLowerCase() + "s"] || [];
        }

        if (filter?.isActive !== undefined && filter?.isActive !== "All") {
          list = list.filter((item) => item.isActive === filter.isActive);
        }

        setData(list);
        setFilteredData(list);
        setLoading(true);
        if (!filter) {
          setFirstRecordId(list.length > 0 ? list[0]?.id : null);
        }
      }
      return list;
    }
    catch (err) {
      console.log(err.message);
      return [];
    }
  };

  const truncateText = (text, maxLen = 25) => {
    if (!text) return "---";
    return text.length > maxLen ? text.substring(0, maxLen) + ".." : text;
  };
  const getSearchableFields = () => {
    if (currentAsset === "Network" || currentAsset === "OtherAsset") {
      const fields = ["systemId", "serialNo", "assetType", "model"];
      if (currentAsset !== "Network") {
        fields.push("assignedTo", "assignedToPrevious");
      }
      return fields;
    }
    // Desktop / Laptop / Monitor
    const fields = ["systemId", "serialNo", "brand", "assignedTo", "assignedToPrevious"];
    if (currentAsset === "Desktop" || currentAsset === "Laptop" || currentAsset === "RentalLaptop") {
      fields.push("brandName", "brandTypeName", "generationName");
    }
    if (currentAsset === "Monitor") {
      fields.push("screensize");
    }
    return fields;
  };

  const handleProcessorName = (brandName, brandTypeName, generationName) => {
    // Helper function to format Intel brand names with ® and ™ symbols
    const formatIntelName = (name) => {
      const [firstWord, secondWord] = name.split(" ");
      return (
        <>
          {firstWord}
          <sup>®</sup> {secondWord}
          <sup>™</sup>
        </>
      );
    };



    // Combine the brand name, type, and generation into one string
    const combinedString = `${brandName || ""} ${brandTypeName || ""} ${generationName || ""
      }`.trim();
    const combinedLength = combinedString.length;

    // Check if the brand is Intel
    const isIntel = brandName?.toLowerCase().includes("intel");

    if (combinedLength > 15) {
      // If the combined string is longer than 15 characters, truncate and add ".."
      const truncatedString = combinedString.substr(0, 15) + "..";
      if (isIntel) {
        // If it's an Intel brand, format the name with ® and ™ symbols
        return (
          <>
            {formatIntelName(brandName)}
            {` ${brandTypeName || ""} ${generationName || ""}`.substr(
              0,
              15 - brandName.length
            )}
            ..
          </>
        );
      }
      return truncatedString;
    } else {
      // If the combined string is 15 characters or less
      if (isIntel) {
        // If it's an Intel brand, format the name with ® and ™ symbols
        return (
          <>
            {formatIntelName(brandName)}
            {brandTypeName && ` ${brandTypeName}`}
            {generationName && ` ${generationName}`}
          </>
        );
      }
      // Default case: Render the brand name, type, and generation normally
      return combinedString;
    }
  };

  const refreshData = (event) => {
    fetchData(event);
  };

  //search functionality
  const handleSearch = (value, filter) => {
    const sourceData = activeToggle === "ewaste" ? ewasteData : data;
    const searchableFields = getSearchableFields();
    const lowerValue = value?.toLowerCase() || "";

    const temp = sourceData.filter((object) =>
      searchableFields.some((key) => {
        const val = object[key];
        return typeof val === "string" && val.toLowerCase().includes(lowerValue);
      })
    );

    let newFilteredData;
    if (activeToggle === "ewaste") {
      newFilteredData = temp;
    } else if (filter !== "All") {
      newFilteredData = temp.filter((item) => item.isActive === filter);
    } else {
      newFilteredData = temp;
    }

    setFilteredData(newFilteredData);
    setCurrentPage(1);
  };

  const reapplySearchAfterUpdate = (list) => {
    if (!searchFilter || searchFilter.trim() === "") {
      setFilteredData(list);
      setCurrentPage(1);
      return;
    }

    const searchableFields = getSearchableFields();
    const lowerValue = searchFilter.toLowerCase();

    const temp = list.filter((object) =>
      searchableFields.some((key) => {
        const val = object[key];
        return typeof val === "string" && val.toLowerCase().includes(lowerValue);
      })
    );

    const stateFilter = filterValue?.state?.value;
    const finalFiltered =
      stateFilter !== "All" ? temp.filter((item) => item.isActive === stateFilter) : temp;

    if (finalFiltered.length > 0) {
      setFilteredData(finalFiltered);
    } else {
      setSearchFilter("");
      setFilteredData(list);
    }
    setCurrentPage(1);
  };

  // To get dropdown data
  const fetchDropdownOptions = async (type) => {
    try {
      if (type === "Network/GetAllNetworkAssetTypeMaster") {
        const networkType = await axiosInstance.get(
          AppSettings.URLs.asset + type
        );
        setDropdownOptions({
          network: networkType?.data?.response?.assets || [],
        });
      } else if (type === "OtherAsset/GetAllOtherAssetTypeMaster") {
        const otherAssetType = await axiosInstance.get(
          AppSettings.URLs.asset + type
        );
        setDropdownOptions({
          other: otherAssetType?.data?.response?.assets || [],
        });
      } else if (type === "Master/GetProcessorType") {
        const processorType = await axiosInstance.get(
          AppSettings.URLs.asset + type
        );
        setDropdownOptions({
          processorType: processorType?.data?.response || [],
        });
      }
    } catch (error) {
      console.log("Error fetching dropdown options:", error);
    }
  };

  const getValueForProcessor = async (query, retainedItem = null) => {
    if (!query || query.length === 0) return;
    try {
      const valueForProcessor = await axiosInstance.get(
        AppSettings.URLs.getValueForProcessor + query
      );

      const brandTypeDetails = valueForProcessor?.data?.response?.brandTypeDetails || [];
      const generationDetails = valueForProcessor?.data?.response?.generationDetails || [];

      setDropdownOptions((prev) => ({
        ...prev,
        processorBrandType: brandTypeDetails,
        processorGeneration: generationDetails,
      }));

      // If called from edit (retainedItem provided), restore the selected values
      if (retainedItem) {
        setSelectedValue((option) => ({
          ...option,
          processorTypeId: {
            value: retainedItem.brandTypeId ?? retainedItem.processorTypeId,
            label: retainedItem.brandTypeName,
          },
          generationId: {
            value: retainedItem.generationId,
            label: retainedItem.generationName,
          },
        }));
      }
      // Only reset if NOT in edit mode and brand changed to one that doesn't have current type
      else if (sidebarAction !== "edit") {
        const typeStillValid = brandTypeDetails.find(
          (obj) => obj.brandTypeId === selectedValue?.processorTypeId?.value
        );
        if (!typeStillValid) {
          setSelectedValue((option) => ({
            ...option,
            processorTypeId: { value: null, label: "Processor type" },
            generationId: { value: null, label: "Processor generation" },
          }));
          setInputValues((input) => ({
            ...input,
            processorTypeId: null,
            generationId: null,
          }));
        }
      }
    } catch (error) {
      console.log("Error fetching dropdown options:", error);
    }
  };

  //Pagination
  const itemsPerPage = 10;
  const totalPages = filteredData
    ? Math.ceil(filteredData?.length / itemsPerPage)
    : 0;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = currentPage * itemsPerPage;
  const displayedData = filteredData
    ? filteredData.slice(startIndex, endIndex)
    : [];
  //const firstRecordId = data && data.length > 0 ? data[0]?.id : null;
  const [firstRecordId, setFirstRecordId] = useState(null);
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const goToNextPage = () => {
    if (endIndex < filteredData?.length) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };
  const renderPageNumbers = () => {
    const maxPageNumbersToShow = 3;
    const pageNumbers = [];
    let startPage;
    let endPage;

    if (totalPages <= maxPageNumbersToShow) {
      startPage = 1;
      endPage = totalPages;
    } else {

      const middlePage = Math.ceil(maxPageNumbersToShow / 2);
      if (currentPage <= middlePage) {
        startPage = 1;
        endPage = maxPageNumbersToShow;
      } else if (currentPage + middlePage - 1 >= totalPages) {
        startPage = totalPages - maxPageNumbersToShow + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - middlePage + 1;
        endPage = currentPage + middlePage - 1;
      }
    }

    if (startPage > 1) {
      pageNumbers.push(1);
      if (startPage > 2) {
        pageNumbers.push("...");
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }
      pageNumbers.push(totalPages);
    }

    return pageNumbers.map((pageNumber) =>
      typeof pageNumber === "number" ? (
        <li
          key={pageNumber}
          className={`inline-block cursor-pointer hover:backdrop-brightness-90 ${currentPage === pageNumber ? "current" : ""
            }`}
          onClick={() => setCurrentPage(pageNumber)}
        >
          <span>{pageNumber}</span>
        </li>
      ) : (
        <li key={pageNumber} className="inline-block mx-1">
          {pageNumber}
        </li>
      )
    );
  };

  const handleSidebarOpen = async (action, item) => {
    setIsSidebarOpen(true);
    setSidebarAction(action);
    setEditItemId(item?.id);
    setIsSubmitting(false);
    if (item !== null) {
      // setInputValues({
      //   ...item,
      //   systemId: item.systemId.slice(7),
      // });
      setInputValues({
        ...item,
        processorTypeId: item?.brandTypeId ?? item?.processorTypeId,
        systemId: item.systemId.slice(7),
        // isRental: item?.isRental === "Yes" || item?.isRental === true ? "Yes" : "",
      });
      setSelectedValue({

        assetType: { value: item?.assetType, label: item?.assetType },
        diskName: { value: item?.diskName, label: item?.diskName },
        networkPort: { value: item?.networkPort, label: item?.networkPort },
        imei: { value: item?.imei, label: item?.imei },
        location: { value: item?.location, label: item?.location },
        model: { value: item?.model, label: item?.model },
        wiredStatus: { value: item?.wiredStatus, label: item?.wiredStatus },
        os: { value: item?.os, label: item?.os },
        //
        serialNo: { value: item?.serialNo, label: item?.serialNo },
        // systemId: {
        //   value: item?.systemId.slice(7),
        //   label: item?.systemId.slice(7),
        // },
        modelNo: { value: item?.modelNo, label: item?.modelNo },
        macId: { value: item?.macId, label: item?.macId },
        biosVersion: { value: item?.biosVersion, label: item?.biosVersion },
        dimension: { value: item?.dimension, label: item?.dimension },
        brand: { value: item?.brand, label: item?.brand },
        ram: { value: item?.ram, label: item?.ram },
        brandId: { value: item?.brandId, label: item?.brandName },
        processorTypeId: {
          value: item?.brandTypeId ?? item?.processorTypeId,
          label: item?.brandTypeName,
        },
        generationId: {
          value: item?.generationId,
          label: item?.generationName,
        },
        generation: { value: item?.generation, label: item?.generation },
        storageType: { value: item?.storageType, label: item?.storageType },
        windowsOS: { value: item?.windowsOS, label: item?.windowsOS },
        storageSize: { value: item?.storageSize, label: item?.storageSize },
        graphicCard: { value: item?.graphicCard, label: item?.graphicCard },
        screensize: { value: item?.screensize, label: item?.screensize },
        purchaseDate: {
          value: item?.purchaseDate,
          label: item?.purchaseDate?.split("T")[0],
        },

        warrantyTill: {
          value: item?.warrantyTill || null,
          label: item?.warrantyTill?.split("T")[0] || "",
        },
        // isActive: {
        //   value: item?.isActive,
        //   label: item?.isActive === true ? "Yes" : "No",
        // },
        // createdBy: { value: item?.createdBy, label: item?.createdBy },
        createdOn: {
          value: item?.createdOn,
          label: item?.createdOn?.split("T")[0],
        },
        // isMonitor: {
        //   value: item?.isMonitor,
        //   label: item?.isMonitor === true ? "Yes" : "No",
        // },
        // isKeyboard: {
        //   value: item?.isKeyboard,
        //   label: item?.isKeyboard === true ? "Yes" : "No",
        // },
        // isMouse: {
        //   value: item?.isMouse,
        //   label: item?.isMouse === true ? "Yes" : "No",
        // },
        // isHeadSet: {
        //   value: item?.isHeadSet,
        //   label: item?.isHeadSet === true ? "Yes" : "No",
        // },
        isAVInstalled: {
          value: item?.isAVInstalled,
          label: item?.isAVInstalled === true ? "Yes" : "No",
        },
        isLicensed: {
          value: item?.isLicensed,
          label:
            item?.isLicensed === true
              ? inputValues?.windowsOS === "Linux"
                ? "Paid Version"
                : "yes"
              : inputValues?.windowsOS === "Linux"
                ? "Free Version"
                : "No",
        },

        isWarrantyTill: {
          value: item?.isWarrantyTill,
          label: item?.isWarrantyTill === true ? "Active" : "In Active",
        },
        windowsLicense: {
          value: item?.windowsLicense,
          label: item?.windowsLicense,
        },
        isActive: {
          value: item?.isActive,
          label: item?.isActive === true ? "Active" : "In Active",
        },
        remarks: { value: item?.remarks, label: item?.remarks },
        ipAddress: { value: item?.ipAddress, label: item?.ipAddress },
      });
      if (item?.brandName && (currentAsset === "Desktop" || currentAsset === "Laptop" || currentAsset === "RentalLaptop")) {
        getValueForProcessor(item.brandName, item);
      }
    } else {
      setInputValues((values) => ({
        ...values,
        // purchaseDate: new Date().toISOString().substr(0, 10),
        // warrantyTill: new Date(
        //   new Date().setFullYear(new Date().getFullYear() + 2)
        // )
        //   .toISOString()
        //   .substr(0, 10),
        purchaseDate: null,
        warrantyTill: null,
        remarks: "",
        // isRental: "",
      }));

      setSelectedValue({
        // network and other asset
        assetType: { value: null, label: "Type" },
        diskName: { value: null, label: "" },
        networkPort: { value: null, label: "" },
        imei: { value: null, label: "" },
        location: { value: null, label: "" },
        model: { value: null, label: "" },
        wiredStatus: { value: null, label: "Wired status" },
        os: { value: null, label: "" },
        //
        serialNo: { value: null, label: "" },
        // systemId: { value: null, label: "" },
        modelNo: { value: null, label: "" },
        macId: { value: null, label: "" },
        biosVersion: { value: null, label: "" },
        brand: { value: null, label: "" },
        dimension: { value: null, label: "" },
        ram: { value: null, label: "" },
        processor: { value: null, label: "" },
        brandId: { value: null, label: "Processor brand" },
        processorTypeId: { value: null, label: "Processor type" },
        generationId: { value: null, label: "Processor generation" },
        storageType: { value: null, label: "Storage Type" },
        windowsOS: { value: null, label: "OS Type" },
        storageSize: { value: null, label: "" },
        graphicCard: { value: null, label: "" },
        screensize: { value: null, label: "" },
        purchaseDate: {
          value: null,
          label: "Purchase Date",
        },
        warrantyTill: { value: null, label: "Warranty Till" },
        isWarrantyTill: { value: null, label: "Warranty" },
        // isActive: { value: null, label: "Is Active" },
        // createdBy: { value: null, label: "" },
        createdOn: { value: null, label: "" },
        // isMonitor: { value: null, label: "is Monitor" },
        // isKeyboard: { value: null, label: "Keyboard" },
        //isMouse: { value: null, label: "Mouse" },
        // isHeadSet: { value: null, label: "HeadSet" },
        isAVInstalled: { value: null, label: "AVInstalled" },
        isLicensed: {
          value: null,
          label:
            inputValues.windowsOS === "Mac Os" ||
              inputValues.windowsOS === "Windows" ||
              inputValues.windowsOS === undefined ||
              inputValues.windowsOS === null ||
              ""
              ? "Licensed/Not"
              : "License Type",
        },
        windowsLicense: { value: null, label: "" },
        isActive: { value: null, label: "State" },
        remarks: { value: null, label: "" },
        ipAddress: { value: null, label: "" },
      });
    }
  };

  //To Close SideBar
  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
    setSidebarAction("");
    setEditItemId(null);
    setIsSubmitting(false);
    setInputValues({});
    setSelectedValue({
      //network and otherAssset
      assetType: { value: null, label: "" },
      diskName: { value: null, label: "" },
      networkPort: { value: null, label: "" },
      imei: { value: null, label: "" },
      location: { value: null, label: "" },
      model: { value: null, label: "" },
      wiredStatus: { value: null, label: "Wired Status" },
      os: { value: null, label: "" },
      //
      serialNo: { value: null, label: "" },
      // systemId: { value: null, label: "" },
      modelNo: { value: null, label: "" },
      macId: { value: null, label: "" },
      biosVersion: { value: null, label: "" },
      brand: { value: null, label: "" },
      dimension: { value: null, label: "" },
      ram: { value: null, label: "" },
      brandId: { value: null, label: "" },
      processorTypeId: { value: null, label: "" },
      generationId: { value: null, label: "" },
      generation: { value: null, label: "" },
      storageType: { value: null, label: "Storage Type" },
      windowsOS: { value: null, label: "OS Type" },
      storageSize: { value: null, label: "" },
      graphicCard: { value: null, label: "" },
      screensize: { value: null, label: "" },
      purchaseDate: { value: null, label: "" },
      warrantyTill: { value: null, label: "" },
      isWarrantyTill: { value: null, label: "Warranty" },
      // isActive: { value: null, label: "Is Active" },
      // createdBy: { value: null, label: "" },
      createdOn: { value: null, label: "" },
      // isMonitor: { value: null, label: "is Monitor" },
      // isKeyboard: { value: null, label: "Keyboard" },
      // isMouse: { value: null, label: "Mouse" },
      // isHeadSet: { value: null, label: "HeadSet" },
      isAVInstalled: { value: null, label: "AVInstalled" },
      isLicensed: {
        value: null,
        label:
          inputValues.windowsOS === "Mac Os" ||
            inputValues.windowsOS === "Windows" ||
            inputValues.windowsOS === undefined ||
            inputValues.windowsOS === null ||
            ""
            ? "Licensed/Not"
            : "License Type",
      },
      windowsLicense: { value: null, label: "" },
      isActive: { value: null, label: "State" },
      remarks: { value: null, label: "" },
      ipAddress: { value: null, label: "" },
    });
    setDataError({
      //network and other assets
      assetType: false,
      diskName: false,
      networkPort: false,
      imei: false,
      location: false,
      model: false,
      wiredStatus: false,
      os: false,
      //
      // biosVersion: false,
      brand: false,
      dimension: false,
      generation: false,
      // macId: false,
      brandId: false,
      processorTypeId: false,
      generationId: false,
      purchaseDate: false,
      ram: false,
      serialNo: false,
      // systemId: false,
      modelNo: false,
      storageSize: false,
      graphicCard: false,
      storageType: false,
      windowsOS: false,
      // warrantyTill: false,
      isWarrantyTill: false,
      isAssigned: false,
      // isActive: false,
      // createdBy: false,
      // createdOn: false,
      // isMonitor: false,
      // isKeyboard: false,
      // isMouse: false,
      // isHeadSet: false,
      isAVInstalled: false,
      // windowsLicense: false,
      // isLicensed: false,
      isActive: false,
      ipAddress: false,
      // remarks: false,
      screensize: false,
    });
  };


  const handlePositiveIntegerChange = (e, name, maxLen = 4) => {
    let digitsOnly = e.target.value.replace(/[^0-9]/g, "").replace(/^0+/, "");
    digitsOnly = digitsOnly.slice(0, maxLen);
    handleInputChange({ target: { value: digitsOnly, type: e.target.type } }, name);
  };

  // const handleRentalChange = (e) => {
  //   const checked = e.target.checked;
  //   setInputValues((prev) => ({
  //     ...prev,
  //     isRental: checked ? "Yes" : "",
  //   }));
  // };

  const handleInputChange = (e, name) => {
    let value;
    if (e && e.target) {

      if (e.target.type === "radio") {
        if (e.target.checked) {
          value = parseInt(e.target.value);
          setSelectedValue((option) => ({
            ...option,
            [name]: { value: null, label: value },
          }));
        } else {
          value = "";
          setSelectedValue((option) => ({
            ...option,
            [name]: { value: null, label: value },
          }));
        }
      } else {

        value = e.target.value;
        if (CAPITALIZE_SINGLE_SPACE_FIELDS[name] !== undefined) {
          value = formatCapitalizedInput(value, CAPITALIZE_SINGLE_SPACE_FIELDS[name]);
        }
        setSelectedValue((option) => ({
          ...option,
          [name]: { value: null, label: value },
        }));
      }
    } else {

      value = e ? e[0]?.value : "";
      setSelectedValue((option) => ({
        ...option,
        [name]: { value: e ? e[0]?.value : "", label: e ? e[0]?.label : "" },
      }));
    }
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [name]: value,
      createdOn: new Date().toISOString().substr(0, 10),
    }));
    if (sidebarAction === "edit") {
      setInputValues((prevInputValues) => ({
        ...prevInputValues,
        changeInRemarks: true,
      }));
    }
  };
  const handleSidebarFormSubmit = (event) => {
    // event.preventDefault();
    if (isSubmitting) return;
    let isFormFilled = false;
    setDataError({
      // network and other asset
      assetType:
        inputValues?.assetType === undefined || inputValues?.assetType === null
          ? true
          : false,
      diskName:
        inputValues?.diskName === undefined ||
          inputValues?.diskName === "" ||
          inputValues?.diskName === null
          ? true
          : false,
      networkPort:
        inputValues?.networkPort === undefined ||
          inputValues?.networkPort === "" ||
          inputValues?.networkPort === null
          ? true
          : false,
      imei:
        inputValues?.imei === undefined ||
          inputValues?.imei === "" ||
          inputValues?.imei === null
          ? true
          : false,
      location:
        inputValues?.location === undefined ||
          inputValues?.location === "" ||
          inputValues?.location === null
          ? true
          : false,
      model:
        inputValues?.model === undefined ||
          inputValues?.model === "" ||
          inputValues?.model === null
          ? true
          : false,
      wiredStatus:
        inputValues?.wiredStatus === undefined ||
          inputValues?.wiredStatus === "" ||
          inputValues?.wiredStatus === null
          ? true
          : false,
      os:
        inputValues?.os === undefined ||
          inputValues?.os === "" ||
          inputValues?.os === null
          ? true
          : false,
      //
      // biosVersion: inputValues?.biosVersion === undefined ? true : false,
      brand:
        inputValues?.brand === undefined ||
          inputValues?.brand === "" ||
          inputValues?.brand === null
          ? true
          : false,
      dimension:
        inputValues?.dimension === undefined ||
          inputValues?.dimension === "" ||
          inputValues?.dimension === null
          ? true
          : false,
      generation:
        inputValues?.generation === undefined ||
          inputValues?.generation === "" ||
          inputValues?.generation === null
          ? true
          : false,
      // macId:
      //   inputValues?.macId === undefined ||
      //   inputValues?.macId === "" ||
      //   inputValues?.macId === null
      //     ? true
      //     : false,
      brandId:
        inputValues?.brandId === undefined ||
          inputValues?.brandId === "" ||
          inputValues?.brandId === null
          ? true
          : false,
      processorTypeId:
        inputValues?.processorTypeId === undefined ||
          inputValues?.processorTypeId === "" ||
          inputValues?.processorTypeId === null
          ? true
          : false,
      generationId:
        inputValues?.generationId === undefined ||
          inputValues?.generationId === "" ||
          inputValues?.generationId === null
          ? true
          : false,
      ram:
        inputValues?.ram === undefined ||
          inputValues?.ram === "" ||
          inputValues?.ram === null
          ? true
          : false,
      isWarrantyTill:
        inputValues?.isWarrantyTill === undefined ||
          inputValues?.isWarrantyTill === null
          ? true
          : false,
      purchaseDate:
        inputValues?.purchaseDate === undefined ||
          inputValues?.purchaseDate === "" ||
          inputValues?.purchaseDate === null
          ? true
          : false,
      // purchaseDate:
      //   (inputValues?.purchaseDate === undefined ||
      //   inputValues?.purchaseDate === "0001-01-01")
      //     ? true
      //     : false,
      // warrantyTill:
      //   (inputValues?.warrantyTill === undefined ||
      //   inputValues?.warrantyTill === "0001-01-01")
      //     ? true
      //     : false,
      // createdOn:
      //   (inputValues?.createdOn === undefined ||
      //   inputValues?.createdOn === "0001-01-01")
      //     ? true
      //     : false,
      serialNo:
        inputValues?.serialNo === undefined ||
          inputValues?.serialNo === "" ||
          inputValues?.serialNo === null
          ? true
          : false,
      // systemId:
      //   inputValues?.systemId === undefined ||
      //     inputValues?.systemId === "" ||
      //     inputValues?.systemId === null
      //     ? true
      //     : false,
      modelNo:
        inputValues?.modelNo === undefined ||
          inputValues?.modelNo === "" ||
          inputValues?.modelNo === null
          ? true
          : false,
      storageSize:
        inputValues?.storageSize === undefined ||
          inputValues?.storageSize === "" ||
          inputValues?.storageSize === null
          ? true
          : false,
      graphicCard:
        currentAsset === "RentalLaptop" &&
          (inputValues?.graphicCard === undefined ||
            inputValues?.graphicCard === "" ||
            inputValues?.graphicCard === null)
          ? true
          : false,
      storageType:
        inputValues?.storageType === undefined ||
          inputValues?.storageType === null
          ? true
          : false,
      windowsOS:
        inputValues?.windowsOS === undefined || inputValues?.windowsOS === null
          ? true
          : false,
      // isActive: inputValues?.isActive === undefined ? true : false,
      // createdBy: (inputValues?.createdBy === undefined||inputValues?.createdBy === "") ? true : false,
      // isMonitor: inputValues?.isMonitor === undefined ? true : false,
      screensize:
        inputValues?.screensize === undefined ||
          inputValues?.screensize === "" ||
          inputValues?.screensize === null
          ? true
          : false,
      // isKeyboard:
      //   inputValues?.isKeyboard === undefined ||
      //     inputValues?.isKeyboard === null
      //     ? true
      //     : false,
      // isMouse:
      //   inputValues?.isMouse === undefined || inputValues?.isMouse === null
      //     ? true
      //     : false,
      // isHeadSet:
      //   inputValues?.isHeadSet === undefined || inputValues?.isHeadSet === null
      //     ? true
      //     : false,
      isAVInstalled:
        inputValues?.isAVInstalled === undefined ||
          inputValues?.isAVInstalled === null
          ? true
          : false,
      // isLicensed:
      //   inputValues?.isLicensed === undefined ||
      //   inputValues?.isLicensed === null
      //     ? true
      //     : false,
      // windowsLicense:
      //   inputValues?.windowsLicense === undefined ||
      //   inputValues?.windowsLicense === "" ||
      //   inputValues?.windowsLicense === null
      //     ? true
      //     : false,

      isActive:
        inputValues?.isActive === undefined || inputValues?.isActive === null
          ? true
          : false,
      // ipAddress:
      //   inputValues?.ipAddress === undefined ||
      //   inputValues?.ipAddress === "" ||
      //   inputValues?.ipAddress === null
      //     ? true
      //     : false,
      // remarks: (inputValues?.remarks === undefined||inputValues?.remarks === "") ? true : false,
    });

    if (
      inputValues?.purchaseDate &&
      String(inputValues.purchaseDate).split("T")[0] > getTodayDateString()
    ) {
      setDataError((prev) => ({ ...prev, purchaseDate: true }));
      toast.error("Purchase Date cannot be a future date", { toastId: customId });
      return;
    }

    if (currentAsset === "Monitor") {
      const monitorRequiredFields = [
        { key: "serialNo", label: "S.No (On Box)" },
        { key: "brand", label: "Brand" },
        { key: "modelNo", label: "System Model" },
        { key: "screensize", label: "Screen Size" },
        { key: "purchaseDate", label: "Purchase Date" },
        { key: "isWarrantyTill", label: "Warranty" },
        { key: "isActive", label: "State" },
      ];
      const missing = monitorRequiredFields.find(({ key }) => {
        const val = inputValues?.[key];
        return val === undefined || val === null || val === "";
      });
      if (missing) {
        setDataError((prev) => ({ ...prev, [missing.key]: true }));
        toast.error(`${missing.label} is required`, { toastId: customId });
        return;
      }
      if (
        inputValues?.isWarrantyTill === true &&
        (inputValues?.warrantyTill === undefined || inputValues?.warrantyTill === "")
      ) {
        setDataError((prev) => ({ ...prev, warrantyTill: true }));
        toast.error("Warranty Till is required", { toastId: customId });
        return;
      }
      if (
        sidebarAction === "edit" &&
        inputValues.isAssigned === true &&
        inputValues.isActive === false
      ) {
        toast.error("Please Unassign user", { toastId: customId });
        setDataError((prev) => ({ ...prev, isActive: true }));
        return;
      }
      if (sidebarAction === "add") {
        setIsSubmitting(true);
        axiosInstance
          .post(AppSettings.URLs.asset + currentAsset + "/Add" + currentAsset + "DataAsync", inputValues)
          .then((res) => {
            if (res?.data?.statuscode === 200) {
              handleSidebarClose();
              setInputValues({});
              fetchData(currentAsset).then(reapplySearchAfterUpdate);
              toast.success(res?.data?.message || "Submitted Successfully", { toastId: customId });
            } else {
              toast.error(res?.data?.message || "Something went wrong", { toastId: customId });
              setIsSubmitting(false);
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong", { toastId: customId });
            setIsSubmitting(false);
          });
      } else if (sidebarAction === "edit") {
        setIsSubmitting(true);
        axiosInstance
          .post(
            AppSettings.URLs.asset + currentAsset + "/Update" + currentAsset + "DetailAsync?id=" + editItemId,
            inputValues
          )
          .then((res) => {
            if (res?.data?.statuscode === 200) {
              handleSidebarClose();
              setInputValues({});
              fetchData(currentAsset).then(reapplySearchAfterUpdate);
              toast.success(res?.data?.message || "Updated Successfully", { toastId: customId });
            } else {
              toast.error(res?.data?.message || "Something went wrong", { toastId: customId });
              setIsSubmitting(false);
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong", { toastId: customId });
            setIsSubmitting(false);
          });
      }
      return;
    }

    if (
      inputValues?.serialNo !== undefined &&
      inputValues?.serialNo !== "" &&
      // (currentAsset !== "Network"
      //   ? inputValues?.systemId !== undefined && inputValues?.systemId !== ""
      //   : true) &&
      // (currentAsset==="Network" || "OtherAsset"?(inputValues?.model !== undefined&&inputValues?.model !== ""):(inputValues?.modelNo !== undefined&&inputValues?.modelNo !== "")) &&
      // ( currentAsset==="Network" || "OtherAsset"?true:(inputValues?.brand !== undefined&&inputValues?.brand !== "")) &&
      // inputValues?.isActive !== undefined &&
      // (inputValues?.createdBy !== undefined&&inputValues?.createdBy !== "") &&
      inputValues?.isActive !== undefined &&
      inputValues?.purchaseDate !== undefined &&
      inputValues?.purchaseDate !== "" &&
      inputValues?.isWarrantyTill !== undefined &&
      inputValues?.isWarrantyTill !== null &&
      (inputValues?.isWarrantyTill === false ||
        (inputValues?.warrantyTill !== undefined &&
          inputValues?.warrantyTill !== ""))


      // (inputValues?.remarks !== undefined&&inputValues?.remarks !== "") &&
      // inputValues?.purchaseDate !== undefined &&
      // inputValues?.purchaseDate !== "0001-01-01" &&
      // inputValues?.createdOn !== undefined &&
      // inputValues?.createdOn !== "0001-01-01" &&
      // inputValues?.warrantyTill !== undefined &&
      // inputValues?.warrantyTill !== "0001-01-01"
    ) {
      if (currentAsset === "Desktop" || currentAsset === "Laptop" || currentAsset === "RentalLaptop") {
        if (
          inputValues?.brandId !== undefined &&
          inputValues?.brandId !== "" &&
          inputValues?.brandId !== null &&
          inputValues?.processorTypeId !== undefined &&
          inputValues?.processorTypeId !== "" &&
          inputValues?.processorTypeId !== null &&
          inputValues?.generationId !== undefined &&
          inputValues?.generationId !== "" &&
          inputValues?.generationId !== null &&
          inputValues?.ram !== undefined &&
          inputValues?.ram !== "" &&
          inputValues?.storageSize !== undefined &&
          inputValues?.storageSize !== "" &&
          (currentAsset !== "RentalLaptop" ||
            (inputValues?.graphicCard !== undefined &&
              inputValues?.graphicCard !== "" &&
              inputValues?.graphicCard !== null)) &&
          inputValues?.storageType !== undefined &&
          inputValues?.windowsOS !== undefined &&
          inputValues?.generation !== undefined &&
          inputValues?.generation !== "" &&
          inputValues?.isAVInstalled !== undefined
        ) {
          if (currentAsset === "Laptop" || currentAsset === "RentalLaptop") {
            if (
              inputValues?.dimension !== undefined &&
              inputValues?.dimension !== "" &&
              inputValues?.dimension !== null
            ) {
              isFormFilled = true;
            }
          } else {
            isFormFilled = true;
          }
        }
      }
      else if (currentAsset === "Network" || currentAsset === "OtherAsset") {
        if (
          inputValues?.assetType !== undefined &&
          inputValues?.assetType !== "" &&
          inputValues.model !== undefined &&
          inputValues.model !== ""
        ) {
          if (currentAsset === "Network") {
            if (
              inputValues?.ram !== undefined &&
              inputValues?.ram !== "" &&
              inputValues.diskName !== undefined &&
              inputValues.diskName !== "" &&
              inputValues.networkPort !== undefined &&
              inputValues.networkPort !== "" &&
              // inputValues.imei !== undefined &&
              // inputValues.imei !== "" &&
              inputValues.location !== undefined &&
              inputValues.location !== "" &&
              inputValues.os !== undefined &&
              inputValues.os !== ""
              // inputValues?.assetType === "Server" &&
              // inputValues.processor !== undefined &&
              // inputValues.processor !== ""
            ) {
              isFormFilled = true;
            }

            if (inputValues?.assetType === "Server") {
              if (
                inputValues.processor !== undefined &&
                inputValues.processor !== ""
              ) {
                isFormFilled = true;
              } else {
                isFormFilled = false;
              }
            }
          } else if (currentAsset === "OtherAsset") {
            if (
              inputValues.wiredStatus !== undefined &&
              inputValues.wiredStatus !== ""
              // inputValues?.assetType === "Mobile" &&
              // inputValues.imei !== undefined &&
              // inputValues.imei !== ""
            ) {
              isFormFilled = true;
            }
            if (inputValues?.assetType === "Mobile") {
              if (inputValues.imei !== undefined && inputValues.imei !== "") {
                isFormFilled = true;
              } else {
                isFormFilled = false;
              }
            }
          }
        }
      } else if (currentAsset === "Monitor") {
        if (
          inputValues.screensize !== undefined &&
          inputValues.screensize !== ""
        ) {
          isFormFilled = true;
        }
      }
      if (inputValues?.purchaseDate > inputValues?.warrantyTill) {
        isFormFilled = false;
        setDataError((prevDataError) => ({
          ...prevDataError,
          purchaseDate: true,
          warrantyTill: true,
        }));
        toast.error("PurchaseDate can't be greater than warranty till", {
          toastId: customId,
        });
      }
    }

    if (isFormFilled === true) {
      if (
        sidebarAction === "edit" &&
        inputValues.isAssigned === true &&
        inputValues.isActive === false
      ) {
        toast.error("Please Unassign user", {
          toastId: customId,
        });
        setDataError((prevDataError) => ({
          ...prevDataError,
          isActive: true,
        }));
      } else if (sidebarAction === "add") {
        const payload = { ...inputValues };
        if (currentAsset === "Laptop" || currentAsset === "Desktop" || currentAsset === "RentalLaptop") {
          payload.brandTypeId = inputValues.processorTypeId;
        }

        setIsSubmitting(true);

        // ADD
        axiosInstance
          .post(
            AppSettings.URLs.asset + currentAsset + "/Add" + currentAsset + "DataAsync",
            inputValues
          )
          .then((res) => {
            if (res?.data?.statuscode === 200) {
              handleSidebarClose();
              setInputValues({});
              fetchData(currentAsset).then(reapplySearchAfterUpdate);
              toast.success(res?.data?.message || "Submitted Successfully", { toastId: customId });
            } else {
              toast.error(res?.data?.message || "Something went wrong", { toastId: customId });
              setIsSubmitting(false);
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong", { toastId: customId });
            setIsSubmitting(false);
          });
      } else if (sidebarAction === "edit") {
        setIsSubmitting(true);

        axiosInstance
          .post(
            AppSettings.URLs.asset + currentAsset + "/Update" + currentAsset + "DetailAsync?id=" + editItemId,
            inputValues
          )
          .then((res) => {
            if (res?.data?.statuscode === 200) {
              handleSidebarClose();
              setInputValues({});
              fetchData(currentAsset).then(reapplySearchAfterUpdate);
              toast.success(res?.data?.message || "Updated Successfully", { toastId: customId });
            } else {
              toast.error(res?.data?.message || "Something went wrong", { toastId: customId });
              setIsSubmitting(false);
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong", { toastId: customId });
            setIsSubmitting(false);
          });
      }
    } else {
      console.log("inputValues at submit:", inputValues);
      toast.error("Please fill all the required fields", {
        toastId: customId,
      });
    }
  };

  const deleteAsset = (data) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body" style={{ position: "relative" }}>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "32px",
                height: "32px",
                background: "transparent",
                border: "none",
                fontSize: "28px",
                fontWeight: "400",
                lineHeight: "1",
                cursor: "pointer",
                color: "#6c757d",
                opacity: 0.8,
                padding: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.8")}
            >
              ×
            </button>
            <h1>Delete Asset</h1>
            {`Are you sure you want to delete asset: ${data.systemId}`}
            <div className="react-confirm-alert-button-group">
              <button
                onClick={onClose}
              >
                No
              </button>
              <button
                onClick={() => {
                  try {
                    axiosInstance
                      .post(
                        AppSettings.URLs.asset +
                        currentAsset +
                        "/Delete" +
                        currentAsset +
                        "DataAsync?id=" +
                        data.id
                      )
                      .then(() => {
                        fetchData(currentAsset);
                        handleAssetClick(currentAsset);
                        toast.success("Asset deleted successfully", {
                          toastId: customId,
                        });
                      });
                  } catch (error) {
                    toast.error("Something went wrong", {
                      toastId: customId,
                    });
                  }
                  onClose();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };

  function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="border-0 pt-6 px-6 pb-2">
          <h2 className="font-bold color-dark mb-0 text-[14px] uppercase">
            Please add {addProp}
            {/* {currentAsset === "OtherAsset" ? "Other" : "Network"}{" "} */}
            {/* asset type */}
          </h2>
        </Modal.Header>
        <Modal.Body className="py-0 px-6">
          <div className="row mt-2">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="form-group mb-2">
                <label className="kr-form-label">Add {addProp}</label>
                <input
                  type="text"
                  // placeholder={`${currentAsset === "OtherAsset" ? "Other" : "Network"
                  //   } asset type`}
                  placeholder={addProp}
                  className="form-control kr-form-textbox"
                  onChange={handlePopupInput}
                ></input>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-start bg-white py-3 px-6 mt-3">
          <Button className="btn btn-secondary" onClick={props.onHide}>
            Close
          </Button>
          <Button
            className="btn btn-Primary"
            onClick={() => {
              addDropDown();
            }}
          >
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    }
  }, [filteredData]);


  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isSidebarOpen]);

  const showModal = async (event) => {
    await setAddProp(event);
    setModalShow(true);
  };

  let temp;
  const handlePopupInput = async (event) => {
    // event.preventDefault()
    temp = event?.target?.value;
    // await setPopUpInput(event.target.value);
  };

  const addDropDown = () => {
    let isFormFilled = false;
    if (temp?.length > 0) {
      isFormFilled = true;
    }
    if (isFormFilled === true) {
      try {
        let addQuery = "";

        if (addProp === "Processor Brand") {
          addQuery = `AddProcessor?brandName=${temp}`;
          axiosInstance
            .post(AppSettings.URLs.asset + "master/" + addQuery)
            .then((res) => {
              if (res?.data?.statuscode === 200 || res?.data?.response === true) {
                fetchDropdownOptions("Master/GetProcessorType");
                setModalShow(false);
                setSearchFilter("");
                toast.success(res?.data?.message || "Submitted Successfully", { toastId: customId });
              } else {
                toast.error(res?.data?.message || "Something went wrong", { toastId: customId });
              }
            })
            .catch(() => toast.error("Something went wrong", { toastId: customId }));
          return;
        }
        addQuery = `${currentAsset === "OtherAsset"
          ? "CreateOtherAssetTypeMaster"
          : currentAsset === "Desktop" || currentAsset === "Laptop"
            ? "AddGenerations"
            : "CreateNetworkTypeMaster"
          }${currentAsset === "Desktop" || currentAsset === "Laptop"
            ? "?generationName="
            : "?addType="
          }${temp}${currentAsset === "Desktop" || currentAsset === "Laptop"
            ? "&BrandId=" + inputValues?.brandId
            : ""
          }`;
        axiosInstance
          .post(
            AppSettings.URLs.asset +
            (currentAsset === "Desktop" || currentAsset === "Laptop"
              ? "master"
              : currentAsset) +
            "/" +
            addQuery
          )
          .then((res) => {
            const statusCode = res?.data?.statuscode;
            const message = res?.data?.message;

            if (statusCode === undefined || statusCode === 200) {
              if (currentAsset === "Network") {
                fetchDropdownOptions("Network/GetAllNetworkAssetTypeMaster");
              } else if (currentAsset === "OtherAsset") {
                fetchDropdownOptions("OtherAsset/GetAllOtherAssetTypeMaster");
              } else if (currentAsset === "Desktop" || currentAsset === "Laptop") {
                getValueForProcessor(selectedValue?.brandId.label);
              }
              setModalShow(false);
              setSearchFilter("");
              toast.success(message || "Submitted Successfully", {
                toastId: customId,
              });
            } else {
              toast.error(message || "Something went wrong", {
                toastId: customId,
              });
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong", {
              toastId: customId,
            });
          });
      } catch (error) {
        toast.error("Something went wrong", {
          toastId: customId,
        });
      }
    } else {
      toast.error("Input field cannot be empty", {
        toastId: customId,
      });
    }
  };
  return (
    <>
      <div className="page-titles bg-white px-6 ">
        <div className="flex items-center">
          <div className="mr-4 kr-page-back-btn">
            <NavLink to="/master" className="no-underline">
              <button
                type="button"
                className="btn-primary rounded flex items-center justify-center w-8"
              >
                <svg
                  width={18}
                  className="svg-white"
                  x="0px"
                  y="0px"
                  viewBox="0 0 700 700"
                >
                  <g>
                    <path
                      d="M82.9,331.2l148.3,148.3c7.6,7.6,18.6,10.6,29,7.8c10.4-2.8,18.5-10.9,21.2-21.2c2.8-10.4-0.2-21.4-7.8-29l-97.6-96.9
      h304.7c15.8,0,31,6.3,42.1,17.5c11.2,11.2,17.5,26.3,17.5,42.1v79c0,10.6,5.7,20.5,14.9,25.8c9.2,5.3,20.6,5.3,29.8,0
      c9.2-5.3,14.9-15.2,14.9-25.8v-79c0-31.6-12.6-61.9-34.9-84.3c-22.4-22.4-52.7-34.9-84.3-34.9H176.1l97.6-97.6
      c7.6-7.6,10.6-18.6,7.8-29c-2.8-10.4-10.9-18.5-21.2-21.2c-10.4-2.8-21.4,0.2-29,7.8L82.9,288.7c-5.7,5.6-8.9,13.3-8.9,21.2
      S77.2,325.6,82.9,331.2L82.9,331.2z"
                    ></path>
                  </g>
                </svg>
              </button>
            </NavLink>
          </div>
          <div>
            <h2 className="font-bold color-dark text-[14px] mb-0">
              Asset Management
            </h2>
            <span className="text-gray-400 text-[12px]">
              View all the Listed items
            </span>
          </div>
        </div>
      </div>
      <div className="pageBody-inner px-0 pt-0">
        <div className="kr-block">
          <div className="tabs">
            <div className="tab-button-outer">
              <div id="tab-button">
                <li className={`${currentAsset === "Desktop" ? "is-active" : ""}`}>
                  <div
                    className="kr-asset-tab"
                    onClick={() => {
                      handleAssetClick("Desktop");
                    }}
                  >
                    <div
                      className={`kr-emp-tab  ${currentAsset === "Desktop"
                        ? "kr-emp-tab-active border-danger border-top-0 border-end-0 border-start-0 border-2 text-dark"
                        : ""
                        }`}
                    >
                      Desktop
                    </div>
                  </div>
                </li>

                <li
                  className={`${currentAsset === "Laptop" ? "is-active" : ""}`}
                >
                  <div
                    className="kr-asset-tab"
                    onClick={() => {
                      handleAssetClick("Laptop");
                    }}
                  >
                    <div
                      className={`kr-emp-tab  ${currentAsset === "Laptop"
                        ? "kr-emp-tab-active border-danger border-top-0 border-end-0 border-start-0 border-2 text-dark"
                        : ""
                        }`}
                    >
                      LAPTOP
                    </div>
                  </div>
                </li>

                <li
                  className={`${currentAsset === "Monitor" ? "is-active" : ""}`}
                >
                  <div
                    className="kr-asset-tab"
                    onClick={() => handleAssetClick("Monitor")}
                  >
                    <div
                      className={`kr-emp-tab  ${currentAsset === "Monitor"
                        ? "kr-emp-tab-active border-danger border-top-0 border-end-0 border-start-0 border-2 text-dark"
                        : ""
                        }`}
                    >
                      MONITOR
                    </div>
                  </div>
                </li>

                <li
                  className={`${currentAsset === "Network" ? "is-active" : ""}`}
                >
                  <div
                    className="kr-asset-tab"
                    onClick={() => handleAssetClick("Network")}
                  >
                    <div
                      className={`kr-emp-tab  ${currentAsset === "Network"
                        ? "kr-emp-tab-active border-danger border-top-0 border-end-0 border-start-0 border-2 text-dark"
                        : ""
                        }`}
                    >
                      Network
                    </div>
                  </div>
                </li>

                <li
                  className={`${currentAsset === "OtherAsset" ? "is-active" : ""
                    }`}
                >
                  <div
                    className="kr-asset-tab"
                    onClick={() => handleAssetClick("OtherAsset")}
                  >
                    <div
                      className={`kr-emp-tab  ${currentAsset === "OtherAsset"
                        ? "kr-emp-tab-active border-danger border-top-0 border-end-0 border-start-0 border-2 text-dark"
                        : ""
                        }`}
                    >
                      Other Asset
                    </div>
                  </div>
                </li>

                <li
                  className={`${currentAsset === "RentalLaptop" ? "is-active" : ""}`}
                >
                  <div
                    className="kr-asset-tab"
                    onClick={() => {
                      handleAssetClick("RentalLaptop");
                    }}
                  >
                    <div
                      className={`kr-emp-tab  ${currentAsset === "RentalLaptop"
                        ? "kr-emp-tab-active border-danger border-top-0 border-end-0 border-start-0 border-2 text-dark"
                        : ""
                        }`}
                    >
                      RENTAL LAPTOP
                    </div>
                  </div>
                </li>
              </div>
            </div>
            {/* <div className="p-6 pb-0 flex gap-2 uppercase font-semibold text-[10px]">
              <span className="p-3 shadow-sm border-[#DD870B] bg-gradient-to-r to-[#ffffff] from-[#FFEACC] rounded-lg w-28">
                Total: {data?.length}
              </span>
              <span className="p-3 shadow-sm border-[#00C396] bg-gradient-to-r to-[#ffffff] from-[#CCFFF3] rounded-lg w-28">
                Active: {data?.filter((item) => item.isActive === true).length}
              </span>
              <span className="p-3 shadow-sm border-[#e2bfff] bg-gradient-to-r to-[#ffffff] from-[#dab5fcc5] rounded-lg w-28">
                Inactive:{" "}
                {data?.filter((item) => item.isActive === false).length}
              </span>
              {(currentAsset.toLocaleLowerCase() === "desktop" ||
                currentAsset.toLocaleLowerCase() === "laptop") && (
                  <>
                    <span className="p-3 shadow-sm border-[#028FF0] bg-gradient-to-r to-[#ffffff] from-[#A4DAFF] rounded-lg w-28">
                      i5:{" "}
                      {
                        data?.filter((item) =>
                          item.processor?.trim().toLowerCase().includes("i5")
                        ).length
                      }
                    </span>
                    <span className="p-3 shadow-sm border-[#F94A4A] bg-gradient-to-r to-[#ffffff] from-[#FFCCCC] rounded-lg w-28">
                      i7:{" "}
                      {
                        data?.filter((item) =>
                          item.processor?.trim().toLowerCase().includes("i7")
                        ).length
                      }
                    </span>
                  </>
                )}
            </div> */}

            <div className="pageBody-inner p-6">
              <div className="kr-block">
                <div className="card !border-none">
                  <div className="card-inner p-0">
                    <div className="kr-table-header border-bottom px-6 py-3">
                      <div className="w-100 flex items-center mb-lg-0 -md-0 justify-between">
                        {/* <div className="kr-table-filter">
                          <div className="dropdown">
                            <button
                              type="button"
                              className="flex items-center p-2 px-3 btn btn-light border border-solid  border-gray-200 btn"
                              aria-expanded="false"
                            >
                              <svg
                                width="12"
                                x="0px"
                                y="0px"
                                viewBox="0 0 700 700"
                              >
                                <g>
                                  <path
                                    d="M618.3,89.7H81.7c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.8,22.4,38.7,22.4h536.6
                                        c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C649,98.2,634.3,89.7,618.3,89.7z"
                                  ></path>
                                  <path
                                    d="M528.9,313.3H171.1c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.8,22.4,38.7,22.4h357.7
                                        c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C559.6,321.8,544.8,313.3,528.9,313.3L528.9,313.3z"
                                  ></path>
                                  <path
                                    d="M439.4,536.9H260.6c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.7,22.4,38.7,22.4h178.9
                                        c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C470.2,545.4,455.4,536.9,439.4,536.9z"
                                  ></path>
                                </g>
                              </svg>
                              <span className="pl-2">Filter</span>
                            </button>
                          </div>
                        </div> */}
                        {/* <div className="flex gap-2 ">
                          <Select
                            searchable={false}
                            backspaceDelete={false}
                            placeholder="All"
                            name="wiredStatus"
                            values={[filterValue?.state]}
                            className={`form-control kr-form-textbox !w-36 ${dataError.wiredStatus === false ? "" : "dataError"
                              }`}
                            options={[
                              { value: "All", label: "All" },
                              { value: true, label: "Active" },
                              { value: false, label: "In-Active" },
                            ]}
                            onChange={(selectedOption) => {
                              setFilterValue({
                                ...filterValue,
                                state: {
                                  value: selectedOption[0].value,
                                  label: selectedOption[0].label,
                                },
                              });
                              // handleFilterChange(selectedOption[0].value);
                              handleSearch(
                                searchFilter,
                                selectedOption[0].value
                              );
                            }}
                          />

                          {(currentAsset === "Laptop" ||
                            currentAsset === "Desktop") && (
                              <>
                                <Select
                                  searchable={false}
                                  backspaceDelete={false}
                                  placeholder="Processor brand"
                                  name="brandId"
                                  values={[filterValue?.brandId ?? []]}
                                  className={`form-control kr-form-textbox !w-36 ${dataError?.brandId === false
                                    ? ""
                                    : "dataError"
                                    }`}
                                  options={dropdownOptions?.processorType?.map(
                                    (option) => ({
                                      value: option?.brandId,
                                      label: option?.brandName,
                                    })
                                  )}
                                  onChange={(selectedOption) => {
                                    fetchData(currentAsset, {
                                      brandId: selectedOption[0].value,
                                    });
                                    setFilterValue({
                                      ...filterValue,
                                      brandId: {
                                        value: selectedOption[0].value,
                                        label: selectedOption[0].label,
                                      },
                                      processorTypeID: {
                                        value: null,
                                        label: "Type",
                                      },
                                      generationId: {
                                        value: null,
                                        label: "Generation",
                                      },
                                    });
                                    getValueForProcessor(selectedOption[0].label);
                                  }}
                                />
                                <Select
                                  searchable={false}
                                  backspaceDelete={false}
                                  placeholder="Processor type"
                                  name="processorType"
                                  disabled={!filterValue?.brandId?.value}
                                  values={[filterValue?.processorTypeID ?? []]}
                                  className={`form-control kr-form-textbox !w-36 ${dataError?.processorTypeId === false
                                    ? ""
                                    : "dataError"
                                    }`}
                                  options={dropdownOptions?.processorBrandType?.map(
                                    (option) => ({
                                      value: option?.brandTypeId,
                                      label: option?.brandTypeName,
                                    })
                                  )}
                                  onChange={(selectedOption) => {
                                    fetchData(currentAsset, {
                                      brandId: filterValue?.brandId?.value,
                                      generationId: filterValue?.generationId?.value,
                                      processorTypeID: selectedOption[0].value,
                                    });
                                    setFilterValue({
                                      ...filterValue,
                                      processorTypeID: {
                                        value: selectedOption[0].value,
                                        label: selectedOption[0].label,
                                      },
                                    });
                                  }}
                                />
                                <Select
                                  searchable={false}
                                  backspaceDelete={false}
                                  disabled={!filterValue?.brandId?.value}
                                  placeholder="Processor generation"
                                  name="generationId"
                                  values={[filterValue?.generationId ?? []]}
                                  className={`form-control kr-form-textbox !w-36 ${dataError?.generationId === false
                                    ? ""
                                    : "dataError"
                                    }`}
                                  options={dropdownOptions?.processorGeneration?.map(
                                    (option) => ({
                                      value: option?.generationId,
                                      label: option?.generation,
                                    })
                                  )}
                                  onChange={(selectedOption) => {
                                    fetchData(currentAsset, {
                                      brandId: filterValue?.brandId?.value,
                                      processorTypeID: filterValue?.processorTypeID?.value,
                                      generationId: selectedOption[0].value,
                                    });
                                    setFilterValue({
                                      ...filterValue,
                                      generationId: {
                                        value: selectedOption[0].value,
                                        label: selectedOption[0].label,
                                      },
                                    });
                                  }}
                                />
                                {/* <button
                                  type="button"
                                  className=" btn-primary rounded flex items-center justify-center w-[40px]"
                                  onClick={() => {
                                    clearFilter();
                                    fetchData(currentAsset);
                                  }}
                                >
                                  <svg
                                    fill="#ffffff"
                                    width="20px"
                                    height="20px"
                                    viewBox="0 0 1920 1920"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0"
                                      fill-rule="evenodd"
                                    />
                                  </svg>
                            //     </button> */}
                        {/* //   </>
                            // )} */}

                        {/* </div> */}
                        {/* 
                        <div className="flex gap-2 items-center">
                          <button
                            type="button"
                            className="flex items-center gap-2 px-3 py-[6px] btn-light border border-solid border-gray-200 rounded text-[12px] font-semibold"
                            onClick={() => setShowFilterPanel(true)}
                          >
                            <svg width="12" viewBox="0 0 700 700" fill="currentColor">
                              <path d="M618.3,89.7H81.7c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.8,22.4,38.7,22.4h536.6c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C649,98.2,634.3,89.7,618.3,89.7z M528.9,313.3H171.1c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.8,22.4,38.7,22.4h357.7c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C559.6,321.8,544.8,313.3,528.9,313.3z M439.4,536.9H260.6c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.7,22.4,38.7,22.4h178.9c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C470.2,545.4,455.4,536.9,439.4,536.9z" />
                            </svg>
                            Filter
                          </button>

                          
                          {filterValue?.brandId?.value && (
                            <span className="flex items-center gap-1 px-2 py-1 bg-orange-100 text-orange-600 rounded-full text-[10px] font-semibold">
                              {filterValue.brandId.label}
                              <button onClick={() => { clearFilter(); fetchData(currentAsset); }} className="ml-1 text-orange-400 hover:text-orange-700">×</button>
                            </span>
                          )}
                        </div> */}
                        <div className="flex gap-2 items-center relative">

                          <button
                            type="button"
                            className="flex items-center gap-2 px-3 py-[6px] btn-light border border-solid border-gray-200 rounded text-[12px] font-semibold"
                            onClick={() => setShowFilterPanel((prev) => !prev)}
                          >
                            <svg width="12" viewBox="0 0 700 700" fill="currentColor">
                              <path d="M618.3,89.7H81.7c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.8,22.4,38.7,22.4h536.6c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C649,98.2,634.3,89.7,618.3,89.7z M528.9,313.3H171.1c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.8,22.4,38.7,22.4h357.7c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C559.6,321.8,544.8,313.3,528.9,313.3z M439.4,536.9H260.6c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.7,22.4,38.7,22.4h178.9c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C470.2,545.4,455.4,536.9,439.4,536.9z" />
                            </svg>
                            Filter
                          </button>
                          <div className="inline-flex items-center gap-1 rounded border border-gray-200 bg-gray-100 p-0.5">
                            <button
                              type="button"
                              onClick={() => {
                                setActiveToggle("Operational");
                                setSelectedRows([]);
                                setCurrentPage(1);
                                setSearchFilter("");
                                clearFilter();
                                fetchData(currentAsset);
                              }}
                              className={`rounded px-4 py-[6px] text-[12px] font-semibold transition-all ${activeToggle === "Operational"
                                ? "bg-[#f97316] text-white shadow-sm"
                                : "text-gray-600 hover:text-gray-800"
                                }`}
                            >
                              Operational
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setActiveToggle("ewaste");
                                setSelectedRows([]);
                                setCurrentPage(1);
                                setSearchFilter("");
                                fetchEWasteData(currentAsset);
                              }}
                              className={`rounded px-4 py-[6px] text-[12px] font-semibold transition-all ${activeToggle === "ewaste"
                                ? "bg-[#22c55e] text-white shadow-sm"
                                : "text-gray-600 hover:text-gray-800"
                                }`}
                            >
                              E-Waste
                            </button>
                          </div>



                          {/* {activeToggle === "ewaste" && (
                            <>
                              <button
                                type="button"
                                className="flex items-center gap-2 px-3 py-[6px] btn-primary rounded text-[12px] font-semibold text-white whitespace-nowrap"
                                onClick={handleDispose}
                              >
                                Dispose
                                {selectedRows.length > 0 && (
                                  <span className="bg-white text-orange-600 rounded-full px-1.5 text-[10px] font-bold">
                                    {selectedRows.length}
                                  </span>
                                )}
                              </button>
                            </>
                          )} */}

                          {activeToggle === "ewaste" && (
                            <button
                              type="button"
                              className="flex items-center gap-2 px-3 py-[6px] btn-primary rounded text-[12px] font-semibold text-white whitespace-nowrap"
                              onClick={handleDispose}
                            >
                              Dispose
                              {selectedRows.length > 0 && (
                                <span className="bg-white text-orange-600 rounded-full px-1.5 text-[10px] font-bold">
                                  {selectedRows.length}
                                </span>
                              )}
                            </button>
                          )}

                          {activeToggle === "Operational" && (
                            <button
                              type="button"
                              className="flex items-center gap-2 px-3 py-[6px] btn-primary rounded text-[12px] font-semibold text-white whitespace-nowrap"
                              style={{ backgroundColor: "#2e7d32" }}
                              onClick={handleMoveSelectedToEwaste}
                            >
                              Move to E-Waste
                              {selectedRows.length > 0 && (
                                <span className="bg-white text-green-700 rounded-full px-1.5 text-[10px] font-bold">
                                  {selectedRows.length}
                                </span>
                              )}
                            </button>
                          )}

                          {showFilterPanel && (
                            <>
                              <div
                                className="fixed inset-0 z-40"
                                onClick={() => setShowFilterPanel(false)}
                              />
                              {/* <div className="absolute top-[38px] left-0 z-50 bg-white border border-gray-200 rounded-lg shadow-xl w-[250px] p-4 flex flex-col gap-2"> */}
                              <div
                                className="absolute top-[38px] left-0 z-50 bg-white border border-gray-200 rounded-lg shadow-xl p-4 flex flex-col gap-2"
                                style={{ width: "420px" }}
                              >
                                {activeToggle === "Operational" ? (
                                  <>
                                    {/* --- Operational filters --- */}
                                    <div>
                                      <label className="kr-form-label mb-1 block text-[12px]">Status</label>
                                      <Select
                                        searchable={false}
                                        backspaceDelete={false}
                                        placeholder="All"
                                        values={[filterValue?.state]}
                                        className="form-control kr-form-textbox"
                                        options={[
                                          { value: "All", label: "All" },
                                          { value: true, label: "Active" },
                                          { value: false, label: "In-Active" },
                                        ]}
                                        onChange={(selectedOption) => {
                                          setFilterValue({ ...filterValue, state: { value: selectedOption[0].value, label: selectedOption[0].label } });
                                        }}
                                      />
                                    </div>

                                    {(currentAsset === "Laptop" || currentAsset === "Desktop" || currentAsset === "RentalLaptop") && (
                                      <>
                                        <div>
                                          <label className="kr-form-label mb-1 block text-[12px]">Processor Brand</label>
                                          <Select
                                            searchable={false}
                                            backspaceDelete={false}
                                            placeholder="Select Processor Brand"
                                            values={[filterValue?.brandId ?? []]}
                                            className="form-control kr-form-textbox"
                                            options={dropdownOptions?.processorType?.map((option) => ({
                                              value: option?.brandId,
                                              label: option?.brandName,
                                            }))}
                                            onChange={(selectedOption) => {
                                              setFilterValue({
                                                ...filterValue,
                                                brandId: { value: selectedOption[0].value, label: selectedOption[0].label },
                                                processorTypeID: { value: null, label: "Type" },
                                                generationId: { value: null, label: "Generation" },
                                              });
                                              getValueForProcessor(selectedOption[0].label);
                                            }}
                                          />
                                        </div>
                                        <div>
                                          <label className="kr-form-label mb-1 block text-[12px]">Processor Type</label>
                                          <Select
                                            searchable={false}
                                            backspaceDelete={false}
                                            placeholder="Select Processor Type"
                                            disabled={!filterValue?.brandId?.value}
                                            values={[filterValue?.processorTypeID ?? []]}
                                            className="form-control kr-form-textbox"
                                            options={(dropdownOptions?.processorBrandType || [])
                                              .filter((o) => o?.brandTypeId != null)
                                              .map((o) => ({ value: o.brandTypeId, label: o.brandTypeName }))}
                                            onChange={(selectedOption) => {
                                              setFilterValue({ ...filterValue, processorTypeID: { value: selectedOption[0].value, label: selectedOption[0].label } });
                                            }}
                                          />
                                        </div>
                                        <div>
                                          <label className="kr-form-label mb-1 block text-[12px]">Generation</label>
                                          <Select
                                            searchable={false}
                                            backspaceDelete={false}
                                            placeholder="Generation"
                                            maxLength={10}
                                            disabled={!filterValue?.brandId?.value}
                                            values={[filterValue?.generationId ?? []]}
                                            className="form-control kr-form-textbox"
                                            options={(dropdownOptions?.processorGeneration || [])
                                              .filter((o) => o?.id != null)
                                              .map((o) => ({ value: o.id, label: o.generation }))}
                                            onChange={(selectedOption) => {
                                              setFilterValue({ ...filterValue, generationId: { value: selectedOption[0].value, label: selectedOption[0].label } });
                                            }}
                                          />
                                        </div>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {/* --- E-Waste filters --- */}
                                    <div>
                                      <label className="kr-form-label mb-1 block text-[12px]">E-Waste Status</label>
                                      <Select
                                        searchable={false}
                                        backspaceDelete={false}
                                        placeholder="All"
                                        values={[filterValue?.eWasteStatus]}
                                        className="form-control kr-form-textbox"
                                        options={[
                                          { value: 0, label: "All" },
                                          ...ewasteStatusList.map((s) => ({ value: s.id, label: s.statusName })),
                                        ]}
                                        onChange={(selectedOption) => {
                                          setFilterValue({ ...filterValue, eWasteStatus: { value: selectedOption[0].value, label: selectedOption[0].label } });
                                        }}
                                      />
                                    </div>
                                    {(currentAsset === "Laptop" || currentAsset === "Desktop" || currentAsset === "RentalLaptop") && (
                                      <>
                                        <div>
                                          <label className="kr-form-label mb-1 block text-[12px]">Processor Brand</label>
                                          <Select
                                            searchable={false}
                                            backspaceDelete={false}
                                            placeholder="Select Processor Brand"
                                            values={[filterValue?.brandId ?? []]}
                                            className="form-control kr-form-textbox"
                                            options={dropdownOptions?.processorType?.map((option) => ({
                                              value: option?.brandId,
                                              label: option?.brandName,
                                            }))}
                                            onChange={(selectedOption) => {
                                              setFilterValue({
                                                ...filterValue,
                                                brandId: { value: selectedOption[0].value, label: selectedOption[0].label },
                                                processorTypeID: { value: null, label: "Type" },
                                                generationId: { value: null, label: "Generation" },
                                              });
                                              getValueForProcessor(selectedOption[0].label);
                                            }}
                                          />
                                        </div>
                                        <div>
                                          <label className="kr-form-label mb-1 block text-[12px]">Processor Type</label>
                                          <Select
                                            searchable={false}
                                            backspaceDelete={false}
                                            placeholder="Select Processot Type"
                                            disabled={!filterValue?.brandId?.value}
                                            values={[filterValue?.processorTypeID ?? []]}
                                            className="form-control kr-form-textbox"
                                            options={(dropdownOptions?.processorBrandType || [])
                                              .filter((o) => o?.brandTypeId != null)
                                              .map((o) => ({ value: o.brandTypeId, label: o.brandTypeName }))}
                                            onChange={(selectedOption) => {
                                              setFilterValue({ ...filterValue, processorTypeID: { value: selectedOption[0].value, label: selectedOption[0].label } });
                                            }}
                                          />
                                        </div>
                                        <div>
                                          <label className="kr-form-label mb-1 block text-[12px]">Generation</label>
                                          <Select
                                            searchable={false}
                                            backspaceDelete={false}
                                            placeholder="Enter Generation"
                                            maxLength={10}
                                            disabled={!filterValue?.brandId?.value}
                                            values={[filterValue?.generationId ?? []]}
                                            className="form-control kr-form-textbox"
                                            options={(dropdownOptions?.processorGeneration || [])
                                              .filter((o) => o?.id != null)
                                              .map((o) => ({ value: o.id, label: o.generation }))}
                                            onChange={(selectedOption) => {
                                              setFilterValue({ ...filterValue, generationId: { value: selectedOption[0].value, label: selectedOption[0].label } });
                                            }}
                                          />
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}

                                <div className="flex gap-2 pt-2 border-t border-gray-100 justify-end">
                                  <button
                                    type="button"
                                    className="flex items-center justify-center py-[6px] px-[12px] btn-light border border-solid border-gray-200 rounded text-[12px]"
                                    onClick={() => {
                                      clearFilter();
                                      if (activeToggle === "Operational") {
                                        fetchData(currentAsset);
                                      } else {
                                        fetchEWasteData(currentAsset);
                                      }
                                      // panel stays open — Clear only resets the selected filter values
                                    }}
                                  >
                                    Clear
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-primary flex items-center justify-center py-[6px] px-[12px] text-[12px]"
                                    onClick={() => {
                                      if (activeToggle === "Operational") {
                                        fetchData(currentAsset, {
                                          brandId: filterValue?.brandId?.value,
                                          processorTypeID: filterValue?.processorTypeID?.value,
                                          generationId: filterValue?.generationId?.value,
                                          isActive: filterValue?.state?.value !== "All" ? filterValue?.state?.value : undefined,
                                        });
                                      } else {
                                        fetchEWasteData(currentAsset, {
                                          eWasteStatus: filterValue?.eWasteStatus?.value || 0,
                                          brandId: filterValue?.brandId?.value,
                                          processorTypeID: filterValue?.processorTypeID?.value,
                                          generationId: filterValue?.generationId?.value,
                                        });
                                      }
                                      setShowFilterPanel(false); // only Apply closes the panel
                                    }}
                                  >
                                    Apply
                                  </button>
                                </div>
                              </div>
                            </>
                          )}

                        </div>

                        <div className=" flex gap-x-2">
                          {/* <CSVLink data={data} filename={`${currentAsset}'s Data`}>
                          <button className=" btn btn-export flex justify-center items-center min-w-80  cursor-pointer whitespace-nowrap ">Export data</button>
                        </CSVLink> */}

                          <div className="flex place-content-center user-search-filter-parent h-[32px]">
                            <input
                              onChange={(e) => {
                                handleSearch(
                                  e.target.value,
                                  filterValue.state.value
                                );
                                setSearchFilter(e.target.value);
                              }}
                              type="text"
                              value={searchFilter}
                              placeholder="Search..."
                              className="user-search-filter-input"
                            />
                          </div>
                          <ExcelExportButton
                            data={filteredData}
                            asset={currentAsset}
                          />

                          <div className="ms-auto lg-flex md-flex block kr-table-header-action">
                            {currentAsset != null && activeToggle === "Operational" && (
                              // <Link to="/add" state={{currentAsset}} className="no-underline">
                              <button
                                type="submit"
                                className="btn btn-primary flex justify-center items-center min-w-80  cursor-pointer"
                                onClick={() => handleSidebarOpen("add", null)}
                              >
                                Create
                              </button>
                              // </Link>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {activeToggle === "Operational" && (
                      <div className="px-6 py-2 flex gap-2 uppercase font-semibold text-[10px] items-center">
                        <span className="p-3 shadow-sm border border-[#DD870B] bg-gradient-to-r to-[#ffffff] from-[#FFEACC] rounded-lg w-28">
                          Total: {data?.length}
                        </span>
                        <span className="p-3 shadow-sm border border-[#00C396] bg-gradient-to-r to-[#ffffff] from-[#CCFFF3] rounded-lg w-28">
                          Active: {data?.filter((item) => item.isActive === true).length}
                        </span>
                        <span className="p-3 shadow-sm border border-[#e2bfff] bg-gradient-to-r to-[#ffffff] from-[#dab5fcc5] rounded-lg w-28">
                          Inactive: {data?.filter((item) => item.isActive === false).length}
                        </span>
                        {(currentAsset.toLocaleLowerCase() === "desktop" ||
                          currentAsset.toLocaleLowerCase() === "laptop" ||
                          currentAsset.toLocaleLowerCase() === "rentallaptop") && (
                            <>
                              <span className="p-3 shadow-sm border border-[#028FF0] bg-gradient-to-r to-[#ffffff] from-[#A4DAFF] rounded-lg w-28">
                                i5: {data?.filter((item) => item.brandTypeName?.trim().toLowerCase() === "i5").length}
                              </span>
                              <span className="p-3 shadow-sm border border-[#F94A4A] bg-gradient-to-r to-[#ffffff] from-[#FFCCCC] rounded-lg w-28">
                                i7: {data?.filter((item) => item.brandTypeName?.trim().toLowerCase() === "i7").length}
                              </span>
                            </>
                          )}
                      </div>
                    )}

                    {currentAsset === "Network" ||
                      currentAsset === "OtherAsset" ? (
                      <div className="kr-block px-3 pt-2 pb-3">
                        <div className="overflow-x-auto">
                          {loading ? (
                            displayedData?.length > 0 ? (
                              <table className="table kr-table-striped">
                                <thead>
                                  <tr>
                                    <th rowSpan="2" className="text-center">
                                      <input
                                        type="checkbox"
                                        className="w-4 h-4 cursor-pointer accent-orange-500"
                                        checked={(() => {
                                          // const selectableCount =
                                          //   activeToggle === "ewaste"
                                          //     ? displayedData.filter((d) => d.eWasteStatus === 1).length
                                          //     : displayedData.filter((d) => !d.assignedTo).length;
                                          const selectableCount =
                                            activeToggle === "ewaste"
                                              ? displayedData.filter((d) => d.eWasteStatus === 1).length
                                              : displayedData.filter((d) => !d.assignedTo && d.eWasteStatus !== 0).length;
                                          return selectableCount > 0 && selectedRows.length === selectableCount;
                                        })()}
                                        disabled={
                                          (activeToggle === "ewaste"
                                            ? displayedData.filter((d) => d.eWasteStatus === 1).length
                                            : displayedData.filter((d) => !d.assignedTo).length) === 0
                                        }
                                        onChange={handleSelectAll}
                                      />
                                    </th>
                                    <th rowSpan="2">#</th>
                                    <th rowSpan="2">System Id</th>
                                    <th rowSpan="2">S.No(on box)</th>
                                    <th rowSpan="2">Asset Type</th>
                                    <th rowSpan="2">Model</th>
                                    {currentAsset !== "Network" ? (
                                      <>
                                        <th rowSpan="2">Assigned To</th>
                                        <th rowSpan="2">Assigned To Prev</th>
                                      </>
                                    ) : null}
                                    {currentAsset === "OtherAsset" && activeToggle !== "ewaste" ? (
                                      <th rowSpan="2">Allocate Asset</th>
                                    ) : null}
                                    {activeToggle === "ewaste" && <th rowSpan="2">E-Waste Status</th>}
                                  </tr>
                                </thead>

                                <tbody>
                                  {displayedData?.map((data, index) => (
                                    <tr
                                      key={index}
                                      className={`relative ${activeToggle === "Operational" && data.eWasteStatus === 0
                                        ? "bg-[linear-gradient(90deg,#fff7ed,#fff_93%)] [&>td:first-child]:!bg-[#fff7ed] [&>td]:!border-y [&>td]:!border-dashed [&>td]:!border-[#fdba74]"
                                        : ""
                                        }`}
                                    >
                                      <td className="whitespace-nowrap text-center">
                                        {/* {(activeToggle === "ewaste" ? data.eWasteStatus === 1 : !data.assignedTo) ? ( */}
                                        {(activeToggle === "ewaste" ? data.eWasteStatus === 1 : !data.assignedTo && data.eWasteStatus !== 0) ? (
                                          <input
                                            type="checkbox"
                                            className="w-4 h-4 cursor-pointer accent-orange-500"
                                            checked={selectedRows.includes(data.id)}
                                            onChange={() => handleRowSelect(data.id)}
                                          />
                                        ) : (
                                          <span className="w-4 h-4 inline-block" />
                                        )}
                                      </td>
                                      <td> {startIndex + index + 1}</td>
                                      <Tooltip title={data.systemId || ""} placement="top" arrow leaveDelay={50}>
                                        <td className="uppercase relative cursor-default">
                                          {activeToggle === "Operational" && data.eWasteStatus === 0 && (
                                            <span className="absolute -top-2 left-10 z-[1] whitespace-nowrap rounded-full bg-[#f97316] px-1.5 py-0 text-[8px] font-medium leading-[13px] text-white">
                                              Approval Pending
                                            </span>
                                          )}
                                          {truncateText(data.systemId)}
                                        </td>
                                      </Tooltip>
                                      {/* <td className="uppercase">
                                        {data.serialNo}
                                      </td> */}
                                      <Tooltip title={data.serialNo || ""} placement="top" arrow leaveDelay={50}>
                                        <td className="uppercase cursor-default">{truncateText(data.serialNo)}</td>
                                      </Tooltip>
                                      <Tooltip title={data?.assetType || ""} placement="top" arrow leaveDelay={50}>
                                        <td className="uppercase cursor-default">{truncateText(data?.assetType)}</td>
                                      </Tooltip>
                                      <Tooltip title={data.model || ""} placement="top" arrow leaveDelay={50}>
                                        <td className="uppercase cursor-default">{truncateText(data.model)}</td>
                                      </Tooltip>

                                      {currentAsset !== "Network" ? (
                                        <>
                                          <Tooltip title={data.assignedTo || ""} placement="top" arrow leaveDelay={50}>
                                            <td className="uppercase cursor-default">
                                              {data.assignedTo?.length > 0 ? truncateText(data.assignedTo) : "---"}
                                            </td>
                                          </Tooltip>
                                          <Tooltip title={data.assignedToPrevious || ""} placement="top" arrow leaveDelay={50}>
                                            <td className="uppercase cursor-default">
                                              {data.assignedToPrevious?.length > 0 ? truncateText(data.assignedToPrevious) : "---"}
                                            </td>
                                          </Tooltip>
                                        </>
                                      ) : null}
                                      {activeToggle === "ewaste" && (
                                        <td className="uppercase whitespace-nowrap">
                                          {ewasteStatusList.find((s) => s.id === data.eWasteStatus)?.statusName || "---"}
                                        </td>
                                      )}

                                      {currentAsset === "OtherAsset" && activeToggle !== "ewaste" ? (
                                        <td>
                                          <AllcoateAsset
                                            data={data}
                                            asset={currentAsset}
                                            getAsset={fetchData}
                                          />
                                        </td>
                                      ) : null}

                                      <td className="kr-tbl-action" style={{ whiteSpace: "nowrap", width: "1px" }}>
                                        <div className="flex justify-start shrink-0">
                                          <ul className="flex flex-nowrap items-center gap-0" style={{ flexWrap: "nowrap" }}>
                                            {currentAsset !== "Network" && (
                                              <li>
                                                <History data={data} asset={currentAsset} />
                                              </li>
                                            )}
                                            <li>
                                              <ViewDetail data={data} asset={currentAsset} />
                                            </li>

                                            {activeToggle !== "ewaste" && (
                                              <>
                                                <li>
                                                  <Tooltip title="Edit" placement="top" arrow leaveDelay={50}>
                                                    <div
                                                      className="kr-tbl-edit cursor-pointer action-item"
                                                      onClick={() => handleSidebarOpen("edit", data)}
                                                    >
                                                      <span className="svg-icon">
                                                        <svg x="0px" y="0px" viewBox="0 0 700 700">
                                                          <g>
                                                            <path d="M631.3,133.8l-80-80C539.9,42.5,524.6,36,508.4,36c-16.2,0-31.5,6.5-42.8,17.8L117.1,402.2c-7.3,7.3-12.1,16.2-15.4,25.9l-49.3,169c-3.2,9.7,0,20.2,7.3,28.3c5.7,5.7,12.9,8.1,20.2,8.1c2.4,0,5.7,0,8.1-0.8l169-49.3c9.7-3.2,18.6-8.1,25.9-15.4l348.4-348.4c11.3-11.3,17.8-26.7,17.8-42.8C649.1,160.5,642.6,145.1,631.3,133.8L631.3,133.8z M147,475l63.1,63.1l-88.9,25.9L147,475z M590.9,179.9l-55,55l-85.7-85.7l55-55c0.8-0.8,2.4-0.8,3.2-0.8c0.8,0,1.6,0,3.2,0.8l80,80c0.8,0.8,0.8,2.4,0.8,3.2C592.5,178.3,591.7,179.1,590.9,179.9z"></path>
                                                          </g>
                                                        </svg>
                                                      </span>
                                                    </div>
                                                  </Tooltip>
                                                </li>

                                                {/* {currentPage === 1 && index === 0 && ( */}
                                                {firstRecordId != null && data.id === firstRecordId && (
                                                  <li>
                                                    <Tooltip title="Delete" placement="top" arrow leaveDelay={50}>
                                                      <div
                                                        className="kr-tbl-delete cursor-pointer action-item"
                                                        onClick={() => deleteAsset(data)}
                                                      >
                                                        <span className="svg-icon">
                                                          <svg x="0px" y="0px" viewBox="0 0 700 700">
                                                            <g>
                                                              <path d="M598.3,144.5H475.1v-26.9c0-19-17.4-33-39.2-33H297.6c-21.8,0-39.2,14.6-39.2,33v26.9H135.7c-12.3,0-21.8,9.5-21.8,21.8c0,12.3,9.5,21.8,21.8,21.8h26.9l26.9,336.6c0.6,39.8,32.5,71.7,72.2,71.7h210c39.8,0,71.7-31.9,72.2-71.7l27.4-336h26.9c12.3,0,21.8-9.5,21.8-21.8C620.1,154.6,610.6,144.5,598.3,144.5L598.3,144.5z M302,127.7H432v16.8l-129.9,0V127.7z M310.4,479.4h-0.6c-11.8,0-20.7-9.5-21.8-20.7l-7.8-176.4c-0.6-12.3,8.4-22.4,20.7-22.4h0.6c11.8,0,20.7,9.5,21.8,20.7l7.8,176.4C331.7,468.7,322.8,478.8,310.4,479.4L310.4,479.4z M446,458.1c-0.6,11.8-10.1,20.7-21.8,20.7h-0.6c-12.3-0.6-20.7-10.6-20.7-22.4l7.8-176.4c0.6-11.8,10.1-20.7,21.8-20.7h0.6c12.3,0.6,20.7,10.6,20.7,22.4L446,458.1z"></path>
                                                            </g>
                                                          </svg>
                                                        </span>
                                                      </div>
                                                    </Tooltip>
                                                  </li>
                                                )}
                                              </>
                                            )}
                                          </ul>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <div className="flex flex-col items-center justify-center gap-2 py-10">
                                <img
                                  src={NoDataFoundImage}
                                  alt="No Data Found"
                                  className="w-[120px] h-[120px] opacity-80"
                                />
                                <span className="text-gray-500 text-[13px] font-semibold">
                                  No Data Found
                                </span>
                              </div>
                            )
                          ) : (
                            <div className="bg-white flex items-center justify-center py-10 m-4">
                              <span className="tableloader"></span>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="kr-block px-3 pt-2 pb-3">
                        <div className="overflow-x-auto">
                          {loading ? (
                            displayedData?.length > 0 ? (
                              <table className="table kr-table-striped">
                                <thead>
                                  <tr>
                                    <th rowSpan="2" className="text-center">
                                      <input
                                        type="checkbox"
                                        className="w-4 h-4 cursor-pointer accent-orange-500"
                                        checked={(() => {
                                          // const selectableCount =
                                          //   activeToggle === "ewaste"
                                          //     ? displayedData.filter((d) => d.eWasteStatus === 1).length
                                          //     : displayedData.filter((d) => !d.assignedTo).length;
                                          const selectableCount =
                                            activeToggle === "ewaste"
                                              ? displayedData.filter((d) => d.eWasteStatus === 1).length
                                              : displayedData.filter((d) => !d.assignedTo && d.eWasteStatus !== 0).length;
                                          return selectableCount > 0 && selectedRows.length === selectableCount;
                                        })()}
                                        disabled={
                                          (activeToggle === "ewaste"
                                            ? displayedData.filter((d) => d.eWasteStatus === 1).length
                                            : displayedData.filter((d) => !d.assignedTo).length) === 0
                                        }
                                        onChange={handleSelectAll}
                                      />
                                    </th>
                                    <th rowSpan="2">#</th>
                                    <th rowSpan="2">System ID</th>
                                    <th rowSpan="2">S.no(on box)</th>

                                    <th rowSpan="2">Brand</th>
                                    {(currentAsset === "Laptop" ||
                                      currentAsset === "Desktop" ||
                                      currentAsset === "RentalLaptop") && (
                                        <th rowSpan="2">Processor</th>
                                      )}
                                    {(currentAsset === "Laptop" ||
                                      currentAsset === "Desktop" ||
                                      currentAsset === "RentalLaptop") && (
                                        <th rowSpan="2">RAM(GB)</th>
                                      )}
                                    {currentAsset === "RentalLaptop" && (     // ★
                                      <th rowSpan="2">Graphic Card(GB)</th>
                                    )}

                                    <th
                                      rowSpan="2"
                                      className={`${currentAsset === "Monitor" ? "" : "hidden"
                                        }`}
                                    >
                                      Screen size
                                    </th>

                                    <th rowSpan="2">Assigned To</th>
                                    <th rowSpan="2">Assigned To Prev</th>
                                    {/* {currentAsset === "Laptop" && (
                                      <th rowSpan="2">Rental</th>
                                    )} */}
                                    <th rowSpan="2">No.of Years</th>

                                    {activeToggle !== "ewaste" && <th rowSpan="2">Allocate Asset</th>}
                                    {activeToggle === "ewaste" && <th rowSpan="2">E-Waste Status</th>}
                                  </tr>
                                </thead>
                                <tbody>
                                  {displayedData.map((data, index) => (
                                    <tr
                                      key={index}
                                      className={`relative ${activeToggle === "Operational" && data.eWasteStatus === 0
                                        ? "bg-[linear-gradient(90deg,#fff7ed,#fff_93%)] [&>td:first-child]:!bg-[#fff7ed] [&>td]:!border-y [&>td]:!border-dashed [&>td]:!border-[#fdba74]"
                                        : ""
                                        }`}
                                    >
                                      <td className="whitespace-nowrap text-center">
                                        {/* {(activeToggle === "ewaste" ? data.eWasteStatus === 1 : !data.assignedTo) ? ( */}
                                        {(activeToggle === "ewaste" ? data.eWasteStatus === 1 : !data.assignedTo && data.eWasteStatus !== 0) ? (
                                          <input
                                            type="checkbox"
                                            className="w-4 h-4 cursor-pointer accent-orange-500"
                                            checked={selectedRows.includes(data.id)}
                                            onChange={() => handleRowSelect(data.id)}
                                          />
                                        ) : (
                                          <span className="w-4 h-4 inline-block" />
                                        )}
                                      </td>
                                      <td>  {startIndex + index + 1}</td>
                                      <Tooltip title={data.systemId || ""} placement="top" arrow leaveDelay={50}>
                                        <td className="uppercase relative cursor-default">
                                          {activeToggle === "Operational" && data.eWasteStatus === 0 && (
                                            <span className="absolute -top-2 left-10 z-[1] whitespace-nowrap rounded-full bg-[#f97316] px-1.5 py-0 text-[8px] font-medium leading-[13px] text-white">
                                              Approval Pending
                                            </span>
                                          )}
                                          {truncateText(data.systemId)}
                                        </td>
                                      </Tooltip>
                                      {/* <td className="uppercase">
                                        {data.serialNo}
                                      </td> */}
                                      <Tooltip title={data.serialNo || ""} placement="top" arrow leaveDelay={50}>
                                        <td className="uppercase cursor-default">
                                          {truncateText(data.serialNo)}
                                        </td>
                                      </Tooltip>

                                      {/* <td className="uppercase">{data.brand}</td> */}
                                      <Tooltip title={data.brand || ""} placement="top" arrow leaveDelay={50}>
                                        <td className="uppercase cursor-default">{truncateText(data.brand)}</td>
                                      </Tooltip>
                                      {(currentAsset === "Laptop" ||
                                        currentAsset === "Desktop" ||
                                        currentAsset === "RentalLaptop") && (
                                          <Tooltip
                                            title={`${data?.brandName + " " || ""}${data?.brandTypeName + " " || ""
                                              }${data?.generationName || ""}`}
                                            placement="top"
                                            arrow
                                            leaveDelay={50}
                                          >
                                            <td className="uppercase cursor-default">
                                              {handleProcessorName(
                                                data?.brandName,
                                                data?.brandTypeName,
                                                data?.generationName
                                              )}
                                            </td>
                                          </Tooltip>
                                        )}
                                      {(currentAsset === "Laptop" ||
                                        currentAsset === "Desktop" ||
                                        currentAsset === "RentalLaptop") && (
                                          <td className="uppercase">{data?.ram}</td>
                                        )}

                                      {currentAsset === "RentalLaptop" && (     // ★
                                        <td className="uppercase">{data?.graphicCard || "---"}</td>
                                      )}

                                      <td
                                        className={`uppercase ${currentAsset === "Monitor"
                                          ? ""
                                          : "hidden"
                                          }`}
                                      >
                                        {data.screensize}
                                      </td>

                                      <Tooltip title={data.assignedTo || ""} placement="top" arrow leaveDelay={50}>
                                        <td className="uppercase cursor-default">
                                          {data.assignedTo?.length > 0 ? truncateText(data.assignedTo) : "---"}
                                        </td>
                                      </Tooltip>

                                      <Tooltip title={data.assignedToPrevious || ""} placement="top" arrow leaveDelay={50}>
                                        <td className="uppercase cursor-default">
                                          {data.assignedToPrevious?.length > 0
                                            ? truncateText(data.assignedToPrevious?.split(" ")[0])
                                            : "---"}
                                        </td>
                                      </Tooltip>
                                      {/* {currentAsset === "Laptop" && (
                                        <td className="uppercase">
                                          {data?.isRental === "Yes" ? "Yes" : "---"}
                                        </td>
                                      )} */}

                                      <td className="lowercase">
                                        {data.noOfMonthsOld != null
                                          ? data.noOfMonthsOld < 12
                                            ? `${data.noOfMonthsOld} months`
                                            : `${(data.noOfMonthsOld / 12).toFixed(1)} years`
                                          : "---"}
                                      </td>

                                      {activeToggle !== "ewaste" ? (
                                        <td>
                                          <AllcoateAsset
                                            data={data}
                                            asset={currentAsset}
                                            getAsset={refreshData}
                                          />
                                        </td>
                                      ) : null}
                                      {activeToggle === "ewaste" && (
                                        <td className="uppercase whitespace-nowrap">
                                          {ewasteStatusList.find((s) => s.id === data.eWasteStatus)?.statusName || "---"}
                                        </td>
                                      )}
                                      <td className="kr-tbl-action" style={{ whiteSpace: "nowrap", width: "1px" }}>
                                        <div className="flex justify-start shrink-0">
                                          <ul className="flex flex-nowrap items-center gap-0" style={{ flexWrap: "nowrap" }}>

                                            <li>
                                              <History data={data} asset={currentAsset} />
                                            </li>
                                            <li>
                                              <ViewDetail data={data} asset={currentAsset} />
                                            </li>

                                            {activeToggle !== "ewaste" && (
                                              <>
                                                <li>
                                                  <Tooltip title="Edit" placement="top" arrow leaveDelay={50}>
                                                    <div
                                                      className="kr-tbl-edit cursor-pointer action-item"
                                                      onClick={() => handleSidebarOpen("edit", data)}
                                                    >
                                                      <span className="svg-icon">
                                                        <svg x="0px" y="0px" viewBox="0 0 700 700">
                                                          <g>
                                                            <path d="M631.3,133.8l-80-80C539.9,42.5,524.6,36,508.4,36c-16.2,0-31.5,6.5-42.8,17.8L117.1,402.2c-7.3,7.3-12.1,16.2-15.4,25.9
      l-49.3,169c-3.2,9.7,0,20.2,7.3,28.3c5.7,5.7,12.9,8.1,20.2,8.1c2.4,0,5.7,0,8.1-0.8l169-49.3c9.7-3.2,18.6-8.1,25.9-15.4
      l348.4-348.4c11.3-11.3,17.8-26.7,17.8-42.8C649.1,160.5,642.6,145.1,631.3,133.8L631.3,133.8z M147,475l63.1,63.1l-88.9,25.9
      L147,475z M590.9,179.9l-55,55l-85.7-85.7l55-55c0.8-0.8,2.4-0.8,3.2-0.8c0.8,0,1.6,0,3.2,0.8l80,80c0.8,0.8,0.8,2.4,0.8,3.2
      C592.5,178.3,591.7,179.1,590.9,179.9z"></path>
                                                          </g>
                                                        </svg>
                                                      </span>
                                                    </div>
                                                  </Tooltip>
                                                </li>

                                                {/* {currentPage === 1 && index === 0 && ( */}
                                                {firstRecordId != null && data.id === firstRecordId && (
                                                  <li>
                                                    <Tooltip title="Delete" placement="top" arrow leaveDelay={50}>
                                                      <div
                                                        className="kr-tbl-delete cursor-pointer action-item"
                                                        onClick={() => deleteAsset(data)}
                                                      >
                                                        <span className="svg-icon">
                                                          <svg x="0px" y="0px" viewBox="0 0 700 700">
                                                            <g>
                                                              <path d="M598.3,144.5H475.1v-26.9c0-19-17.4-33-39.2-33H297.6c-21.8,0-39.2,14.6-39.2,33v26.9H135.7
    c-12.3,0-21.8,9.5-21.8,21.8c0,12.3,9.5,21.8,21.8,21.8h26.9l26.9,336.6c0.6,39.8,32.5,71.7,72.2,71.7h210
    c39.8,0,71.7-31.9,72.2-71.7l27.4-336h26.9c12.3,0,21.8-9.5,21.8-21.8C620.1,154.6,610.6,144.5,598.3,144.5L598.3,144.5z
    M302,127.7H432v16.8l-129.9,0V127.7z M310.4,479.4h-0.6c-11.8,0-20.7-9.5-21.8-20.7l-7.8-176.4
    c-0.6-12.3,8.4-22.4,20.7-22.4h0.6c11.8,0,20.7,9.5,21.8,20.7l7.8,176.4C331.7,468.7,322.8,478.8,310.4,479.4L310.4,479.4z
    M446,458.1c-0.6,11.8-10.1,20.7-21.8,20.7h-0.6c-12.3-0.6-20.7-10.6-20.7-22.4l7.8-176.4
    c0.6-11.8,10.1-20.7,21.8-20.7h0.6c12.3,0.6,20.7,10.6,20.7,22.4L446,458.1z"></path>
                                                            </g>
                                                          </svg>
                                                        </span>
                                                      </div>
                                                    </Tooltip>
                                                  </li>
                                                )}
                                              </>
                                            )}
                                          </ul>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <div className="flex flex-col items-center justify-center gap-2 py-10">
                                <img
                                  src={NoDataFoundImage}
                                  alt="No Data Found"
                                  className="w-[120px] h-[120px] opacity-80"
                                />
                                <span className="text-gray-500 text-[13px] font-semibold">
                                  No Data Found
                                </span>
                              </div>
                            )
                          ) : (
                            <div className="bg-white flex items-center justify-center py-10 m-4">
                              <span className="tableloader"></span>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {displayedData?.length > 0 && (
                      <div className="kr-block pt-3 pb-3 font-size-12px color-gray border-top px-3">
                        <nav className="w-full position:relative m-0">
                          <ul className="list-none ml-0 mb-0 pagination">
                            <li
                              className={`inline-block pagination-prev cursor-pointer ${currentPage === 1 ? "disabled" : ""
                                }`}
                              onClick={goToPreviousPage}
                            >
                              <span>Previous</span>
                            </li>
                            {renderPageNumbers()}
                            <li
                              className={`inline-block pagination-next cursor-pointer ${endIndex >= filteredData?.length ? "disabled" : ""
                                }`}
                              onClick={goToNextPage}
                            >
                              <span>Next</span>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add Asset Side Menu */}
      <div
        className={`kr-popup-overlay ${isSidebarOpen ? "kr-side-popup-overlay" : ""
          }`}
      ></div>
      <div
        className={`kr-side-popup ${isSidebarOpen ? "kr-side-popup-on md:!w-[600px] !w-[90vw]" : ""
          }`}
      >
        <div className="kr-block w-100">
          <div className="flex items-center py-[16px] px-6 bg-gray-50">
            <div className="pl-2">
              <h2 className="font-bold color-dark text-[14px] mb-0">
                {sidebarAction === "add" ? "Create Asset" : "Update Asset"}
              </h2>
              <span className="text-gray-400 text-[12px]">
                {sidebarAction === "add" ? "Create" : "Update"} your Asset below
              </span>
            </div>
          </div>
          <div className="kr-block p-4">
            <div id="form">
              {currentAsset === "Network" || currentAsset === "OtherAsset" ? (
                <div className="grid md:!grid-cols-2 gap-x-4 !grid-cols-1">
                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">
                        {currentAsset === "Network"
                          ? "Network Asset Type"
                          : "AssetType"}
                      </label>
                      <div className="kr-selectform flex kr-select-with-add">
                        <Select
                          searchable={false}
                          backspaceDelete={false}
                          placeholder="Select Network Asset Type"
                          name="assetType"
                          values={[selectedValue?.assetType]}
                          className={`form-control kr-form-textbox ${dataError?.assetType === false ? "" : "dataError"
                            }`}
                          options={
                            currentAsset === "OtherAsset"
                              ? dropdownOptions?.other?.map((option) => ({
                                value: option?.assetType,
                                label: option?.assetType,
                              }))
                              : dropdownOptions?.network?.map((option) => ({
                                value: option?.assetType,
                                label: option?.assetType,
                              }))
                          }
                          onChange={(selectedOption) => {
                            if (sidebarAction === "add") {
                              setInputValues({});
                              setSelectedValue({
                                //network and other asset
                                assetType: {
                                  value: null,
                                  label: "Network Asset Type",
                                },
                                diskName: { value: null, label: "" },
                                networkPort: { value: null, label: "" },
                                imei: { value: null, label: "" },
                                location: { value: null, label: "" },
                                model: { value: null, label: "" },
                                wiredStatus: {
                                  value: null,
                                  label: "Wired status",
                                },
                                os: { value: null, label: "" },
                                //
                                serialNo: { value: null, label: "" },
                                systemId: { value: null, label: "" },
                                modelNo: { value: null, label: "" },
                                macId: { value: null, label: "" },
                                dimension: { value: null, label: "" },
                                biosVersion: { value: null, label: "" },
                                brand: { value: null, label: "" },
                                ram: { value: null, label: "" },
                                brandId: {
                                  value: null,
                                  label: "Processor brand",
                                },
                                processorTypeId: {
                                  value: null,
                                  label: "Processor type",
                                },
                                generationId: {
                                  value: null,
                                  label: "Processor generation",
                                },
                                generation: { value: null, label: "" },
                                storageType: {
                                  value: null,
                                  label: "Storage Type",
                                },
                                windowsOS: { value: null, label: "OS Type" },
                                storageSize: { value: null, label: "" },
                                screensize: { value: null, label: "" },
                                purchaseDate: { value: null, label: "" },
                                isWarrantyTill: {
                                  value: null,
                                  label: "warranty",
                                },
                                warrantyTill: {
                                  value: null,
                                  label: "warranty",
                                },
                                // isActive: { value: null, label: "Is Active" },
                                // createdBy: { value: null, label: "" },
                                createdOn: { value: null, label: "" },
                                // isMonitor: { value: null, label: "is Monitor" },
                                // isKeyboard: { value: null, label: "Keyboard" },
                                // isMouse: { value: null, label: "Mouse" },
                                // isHeadSet: { value: null, label: "HeadSet" },
                                isAVInstalled: {
                                  value: null,
                                  label: "AVInstalled",
                                },
                                isLicensed: {
                                  value: null,
                                  label:
                                    inputValues.windowsOS === "Mac Os" ||
                                      inputValues.windowsOS === "Windows" ||
                                      inputValues.windowsOS === undefined ||
                                      inputValues.windowsOS === null ||
                                      ""
                                      ? "Licensed/Not"
                                      : "License Type",
                                },
                                windowsLicense: { value: null, label: "" },
                                isActive: { value: null, label: "State" },
                                remarks: { value: null, label: "" },
                                ipAddress: { value: null, label: "" },
                              });
                            }
                            handleInputChange(selectedOption, "assetType");
                          }}
                          disabled={sidebarAction === "edit"}
                          dropdownHandle={sidebarAction !== "edit"}
                        />
                        {isAdmin && sidebarAction !== "edit" && (
                          <button
                            type="button"
                            className=" btn-primary rounded !rounded-tl-none !rounded-bl-none flex items-center justify-center w-[46px]"
                            onClick={() =>
                              showModal(currentAsset === "OtherAsset" ? "Other asset type" : "Network asset type")
                            }
                          >
                            <svg width={10} className="svg-white" x="0px" y="0px" viewBox="0 0 34.81 34.81">
                              <g><path d="M17.41,0C16.14,0,15.12,1.03,15.12,2.29V15.12H2.29c-1.26,0-2.29,1.03-2.29,2.29s1.03,2.29,2.29,2.29H15.12v12.83c0,1.26,1.03,2.29,2.29,2.29s2.29-1.03,2.29-2.29v-12.83h12.83c1.26,0,2.29-1.03,2.29-2.29s-1.03-2.29-2.29-2.29h-12.83V2.29c0-1.26-1.03-2.29-2.29-2.29h0Z"></path></g>
                            </svg>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Model </label>
                      <input
                        type="text"
                        placeholder="Enter Model"
                        maxLength={50}
                        value={selectedValue?.model?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.model === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "model")}
                      ></input>
                    </div>
                  </div>

                  {/* <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">System ID </label>
                      <input
                        type="number"
                        placeholder="System ID"
                        max="4"
                        value={selectedValue?.systemId?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.systemId === false ? "" : "dataError"
                          }`}
                        onChange={(e) => {
                          if (e.target.value.length > 4) {
                            e.target.value = e.target.value.slice(0, 4);
                          }
                          handleInputChange(e, "systemId");
                        }}
                      ></input>
                    </div>
                  </div> */}

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Serial Number </label>
                      <input
                        type="text"
                        placeholder="Enter Serial Number"
                        value={selectedValue?.serialNo?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.serialNo === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "serialNo")}
                      ></input>
                    </div>
                  </div>

                  <div
                    className={` col-span-2 md:col-span-1 ${currentAsset === "Network" ? "" : "hidden"
                      }`}
                  >
                    <div className="kr-selectform required">
                      <label className="kr-form-label">RAM (GB)</label>
                      <input
                        type="text"
                        placeholder="Enter RAM Size"
                        min={1}
                        maxLength={4}
                        value={selectedValue?.ram?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.ram === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handlePositiveIntegerChange(e, "ram")}
                      ></input>
                    </div>
                  </div>

                  <div
                    className={` col-span-2 md:col-span-1 ${currentAsset === "OtherAsset" &&
                      inputValues?.assetType === "Mobile"
                      ? ""
                      : "hidden"
                      }`}
                  >
                    <div className="kr-selectform required">
                      <label className="kr-form-label">IMEI </label>
                      <input
                        type="text"
                        placeholder="Enter Imei"
                        value={selectedValue?.imei?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.imei === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "imei")}
                      ></input>
                    </div>
                  </div>

                  <div
                    className={` col-span-2 md:col-span-1 ${currentAsset === "OtherAsset" ? "" : "hidden"
                      }`}
                  >
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Wired Status </label>
                      <Select
                        searchable={false}
                        backspaceDelete={false}
                        placeholder="Select Wired type"
                        name="wiredStatus"
                        values={[selectedValue?.wiredStatus]}
                        className={`form-control kr-form-textbox ${dataError.wiredStatus === false ? "" : "dataError"
                          }`}
                        options={[
                          { value: "Wired", label: "Wired" },
                          { value: "Wireless", label: "wireless" },
                        ]}
                        onChange={(selectedOption) =>
                          handleInputChange(selectedOption, "wiredStatus")
                        }
                      />
                    </div>
                  </div>

                  <div
                    className={` col-span-2 md:col-span-1 ${currentAsset === "Network" ? "" : "hidden"
                      }`}
                  >
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Disk </label>
                      <input
                        type="text"
                        placeholder="Enter Disk"
                        maxLength={50}
                        value={selectedValue?.diskName?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.diskName === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "diskName")}
                      ></input>
                    </div>
                  </div>

                  <div
                    className={` col-span-2 md:col-span-1 ${currentAsset === "Network" ? "" : "hidden"
                      }`}
                  >
                    <div className="kr-selectform required">
                      <label className="kr-form-label">OS </label>
                      <input
                        type="text"
                        placeholder="Enter OS"
                        maxLength={50}
                        value={selectedValue?.os?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.os === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "os")}
                      ></input>
                    </div>
                  </div>

                  {inputValues?.assetType === "Server" ? (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">Processor</label>
                        <input
                          type="text"
                          placeholder="Enter Processor"
                          value={selectedValue?.processor?.label}
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.processor === false ? "" : "dataError"
                            }`}
                          onChange={(e) => handleInputChange(e, "processor")}
                        ></input>
                      </div>
                    </div>
                  ) : null}

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Purchase Date</label>
                      <input
                        min="2001-01"
                        // max={`${new Date().toISOString().slice(0, 7)}`}
                        max={getTodayDateString()}
                        type="date"
                        placeholder="Select Purchase Date"
                        name="PurchaseDate"
                        value={selectedValue?.purchaseDate?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.purchaseDate === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "purchaseDate")}
                        onKeyDown={(e) => e.preventDefault()}
                      ></input>
                    </div>
                  </div>

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Warranty</label>
                      <Select
                        searchable={false}
                        backspaceDelete={false}
                        placeholder="Select Warranty"
                        name="isWarrantyTill"
                        values={[selectedValue?.isWarrantyTill]}
                        className={`form-control kr-form-textbox ${dataError?.isWarrantyTill === false ? "" : "dataError"
                          }`}
                        options={[
                          { value: true, label: "Active" },
                          { value: false, label: "In Active" },
                        ]}
                        onChange={(selectedOption) => {
                          handleInputChange(selectedOption, "isWarrantyTill");
                        }}
                      />
                    </div>
                  </div>

                  {inputValues?.isWarrantyTill === true ? (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">Warranty Till</label>
                        <input
                          min={getTomorrowDateString()}
                          type="date"
                          placeholder="Select Warranty Till"
                          name="Warrantytill"
                          value={selectedValue?.warrantyTill?.label || ""}
                          className={`form-control kr-form-textbox placeholder-[#212529]`}
                          onChange={(e) => handleInputChange(e, "warrantyTill")}
                          onKeyDown={(e) => e.preventDefault()}
                        ></input>
                      </div>
                    </div>
                  ) : null}

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">State</label>
                      <Select
                        searchable={false}
                        backspaceDelete={false}
                        placeholder="Select State"
                        name="State"
                        values={[selectedValue?.isActive]}
                        className={`form-control kr-form-textbox ${dataError.isActive === false ? "" : "dataError"
                          }`}
                        options={[
                          { value: true, label: "Active" },
                          { value: false, label: "In Active" }
                          // { value: false, label: "E-Waste" },
                        ]}
                        onChange={(selectedOption) =>
                          handleInputChange(selectedOption, "isActive")
                        }
                      />
                    </div>
                  </div>

                  <div
                    className={` col-span-2 md:col-span-1 ${currentAsset === "Network" ? "" : "hidden"
                      }`}
                  >
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Network Port </label>
                      <input
                        type="text"
                        placeholder="Enter Network Port"
                        maxLength={50}
                        value={selectedValue?.networkPort?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.networkPort === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "networkPort")}
                      ></input>
                    </div>
                  </div>

                  <div
                    className={` col-span-2 md:col-span-1 ${currentAsset === "Network" ? "" : "hidden"
                      }`}
                  >
                    {/* <div className="kr-selectform required">
                      <label className="kr-form-label">IMEI </label>
                      <input
                        type="text"
                        placeholder="Imei"
                        value={selectedValue?.imei?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${
                          dataError?.imei === false ? "" : "dataError"
                        }`}
                        onChange={(e) => handleInputChange(e, "imei")}
                      ></input>
                    </div> */}
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Location </label>
                      <input
                        type="text"
                        placeholder="Enter Location"
                        maxLength={50}
                        value={selectedValue?.location?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.location === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "location")}
                      ></input>
                    </div>
                  </div>

                  {/* <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform ">
                      <label className="kr-form-label">Created By</label>
                      <input
                        type="text"
                        placeholder="Created By"
                        name="Createdby"
                        value={selectedValue?.createdBy?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] 
                     
                      `}
                        onChange={(e) => handleInputChange(e, "createdBy")}
                        readOnly={sidebarAction === "edit"}
                      ></input>
                    </div>
                  </div> */}

                  {/* <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform ">
                      <label className="kr-form-label">Created On</label>
                      <input
                        type="text"
                        placeholder="Created On"
                        name="Createdon"
                        value={new Date().toISOString().substr(0, 10)}
                        className={`form-control kr-form-textbox placeholder-[#212529] 
                     
                      `}
                        onChange={(e) => handleInputChange(e, "createdOn")}
                        readOnly
                      ></input>
                    </div>
                  </div> */}

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform ">
                      <label className="kr-form-label">Remarks</label>
                      <input
                        type="text"
                        placeholder="Enter Remarks"
                        name="Remarks"
                        maxLength={250}
                        value={selectedValue?.remarks?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] 
                      
                      `}
                        onChange={(e) => handleInputChange(e, "remarks")}
                      ></input>
                    </div>
                  </div>

                  <div className="col-span-2">
                    <div className="kr-selectform flex justify-end">
                      {/* <Link to ='/' className='no-underline'> */}
                      <button
                        type="button"
                        className="flex items-center justify-center py-[6px] px-[12px] btn-light border border-solid border-gray-200 rounded min-w-80"
                        onClick={handleSidebarClose}
                      >
                        Cancel
                      </button>
                      {/* </Link> */}
                      {/* <Link to ='/' className='no-underline'> */}
                      <button
                        type="button"
                        className="btn btn-primary flex items-center justify-center ml-2 min-w-80 disabled:!bg-[#fc5b0b] disabled:!border-[#fc5b0b] disabled:!text-white disabled:!opacity-100 disabled:cursor-not-allowed"
                        onClick={handleSidebarFormSubmit}
                        disabled={isSubmitting}
                      >
                        {isSubmitting
                          ? sidebarAction === "add" ? "Add" : "Update"
                          : sidebarAction === "add" ? "Add" : "Update"}
                      </button>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="grid md:!grid-cols-2 gap-x-4 !grid-cols-1">
                  {/* <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">System ID </label>
                      <input
                        type="number"
                        placeholder="System ID"
                        max="4"
                        value={selectedValue?.systemId?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.systemId === false ? "" : "dataError"
                          }`}
                        onChange={(e) => {
                          if (e.target.value.length > 4) {
                            e.target.value = e.target.value.slice(0, 4);
                          }
                          handleInputChange(e, "systemId");
                        }}
                      ></input>
                    </div>
                  </div> */}

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">S.No (On Box) </label>
                      <input
                        type="text"
                        placeholder="Enter Serial No"
                        maxLength={50}
                        value={selectedValue?.serialNo?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.serialNo === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "serialNo")}
                      ></input>
                    </div>
                  </div>
                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Brand</label>
                      <input
                        type="text"
                        placeholder="Enter Brand"
                        maxLength={50}
                        value={selectedValue?.brand?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.brand === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "brand")}
                      ></input>
                    </div>
                  </div>

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">System Model</label>
                      <input
                        type="text"
                        placeholder="Enter System Model"
                        maxLength={50}
                        value={selectedValue?.modelNo?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.modelNo === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "modelNo")}
                      ></input>
                    </div>
                  </div>

                  {/* for monitor only  */}
                  {currentAsset === "Desktop" || currentAsset === "Laptop" || currentAsset === "RentalLaptop" ? (
                    ""
                  ) : (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label "> Screen Size</label>
                        <input
                          type="text"
                          placeholder="Enter Screen Size"
                          maxLength={50}
                          value={selectedValue?.screensize?.label}
                          name="screensize"
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.screensize === false ? "" : "dataError"
                            }`}
                          onChange={(e) => handleInputChange(e, "screensize")}
                        ></input>
                      </div>
                    </div>
                  )}

                  {/* For CPU and Laptop */}
                  <div
                    className={`col-span-2 md:col-span-1 ${currentAsset === "Desktop" || currentAsset === "Laptop" || currentAsset === "RentalLaptop"
                      ? ""
                      : "hidden"
                      }`}
                  >
                    <div className="kr-selectform">
                      <label className="kr-form-label ">
                        Machine Type Model
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Machine Type Model"
                        maxLength={50}
                        value={selectedValue?.macId?.label}
                        name="MacId"
                        className={`form-control kr-form-textbox placeholder-[#212529]}`}
                        onChange={(e) => handleInputChange(e, "macId")}
                      ></input>
                    </div>
                  </div>

                  {(currentAsset === "Laptop" || currentAsset === "RentalLaptop") && (
                    <div
                      className={`col-span-2 md:col-span-1 ${currentAsset === "Desktop" || currentAsset === "Laptop" || currentAsset === "RentalLaptop"
                        ? ""
                        : "hidden"
                        }`}
                    >
                      <div className="kr-selectform required">
                        <label className="kr-form-label ">Dimension</label>
                        <input
                          type="text"
                          placeholder="Enter Dimension"
                          maxLength={20}
                          value={selectedValue?.dimension?.label}
                          name="dimension"
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.dimension === false ? "" : "dataError"
                            }`}
                          onChange={(e) => handleInputChange(e, "dimension")}
                        ></input>
                      </div>
                    </div>
                  )}

                  <div
                    className={`col-span-2 md:col-span-1 ${currentAsset === "Desktop" || currentAsset === "Laptop" || currentAsset === "RentalLaptop"
                      ? ""
                      : "hidden"
                      }`}
                  >
                    <div className="kr-selectform">
                      <label className="kr-form-label">BIOS Version</label>
                      <input
                        type="text"
                        value={selectedValue?.biosVersion?.label}
                        maxLength={50}
                        placeholder="Enter BIOS Version"
                        name="bios"
                        className={`form-control kr-form-textbox placeholder-[#212529]`}
                        onChange={(e) => handleInputChange(e, "biosVersion")}
                      ></input>
                    </div>
                  </div>
                  {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                    ""
                  ) : (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">RAM (GB)</label>
                        <input
                          type="text"
                          placeholder="Enter RAM Size"
                          min={1}
                          maxLength={4}
                          value={selectedValue?.ram?.label}
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.ram === false ? "" : "dataError"
                            }`}
                          onChange={(e) => handlePositiveIntegerChange(e, "ram")}
                        ></input>
                      </div>
                    </div>
                  )}
                  {currentAsset === "RentalLaptop" && (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">Graphic Card (GB)</label>
                        <input
                          type="text"
                          placeholder="Enter Graphic Card Size"
                          maxLength={4}
                          value={selectedValue?.graphicCard?.label}
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.graphicCard === false ? "" : "dataError"}`}
                          onChange={(e) => handlePositiveIntegerChange(e, "graphicCard")}
                        ></input>
                      </div>
                    </div>
                  )}
                  {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                    ""
                  ) : (
                    <>
                      <div className="col-span-2 md:col-span-1">
                        <div className="kr-selectform required">
                          <label className="kr-form-label">
                            Processor Brand
                          </label>
                          <Select
                            searchable={false}
                            backspaceDelete={false}
                            placeholder="Select Processor brand"
                            name="brandId"
                            values={[selectedValue?.brandId ?? []]}
                            className={`form-control kr-form-textbox ${dataError?.brandId === false ? "" : "dataError"
                              }`}
                            options={dropdownOptions?.processorType?.map(
                              (option) => ({
                                value: option?.brandId,
                                label: option?.brandName,
                              })
                            )}
                            onChange={(selectedOption) => {
                              // Reset type and generation whenever brand changes (both add and edit)
                              setSelectedValue((option) => ({
                                ...option,
                                processorTypeId: {
                                  value: null,
                                  label: "Processor type",
                                },
                                generationId: {
                                  value: null,
                                  label: "Processor generation",
                                },
                              }));
                              setInputValues((input) => ({
                                ...input,
                                processorTypeId: null,
                                generationId: null,
                              }));
                              handleInputChange(selectedOption, "brandId");
                              getValueForProcessor(selectedOption[0].label);
                            }}
                          />
                        </div>
                      </div>

                      {inputValues?.brandId && (
                        <>
                          <div className="col-span-2 md:col-span-1">
                            <div className="kr-selectform required">
                              <label className="kr-form-label">
                                Processor Type
                              </label>
                              <Select
                                searchable={false}
                                backspaceDelete={false}
                                placeholder="Select Processor type"
                                name="processorType"
                                values={[selectedValue?.processorTypeId ?? []]}
                                className={`form-control kr-form-textbox ${dataError?.processorTypeId === false
                                  ? ""
                                  : "dataError"
                                  }`}
                                options={dropdownOptions?.processorBrandType?.map(
                                  (option) => ({
                                    value: option?.brandTypeId,
                                    label: option?.brandTypeName,
                                  })
                                )}
                                // onChange={(selectedOption) =>
                                //   handleInputChange(
                                //     selectedOption,
                                //     "processorTypeId"
                                //   )
                                // }
                                // WITH:
                                onChange={(selectedOption) => {
                                  handleInputChange(selectedOption, "processorTypeId");
                                  setInputValues((prev) => ({
                                    ...prev,
                                    brandTypeId: selectedOption[0].value,
                                  }));
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-span-2 md:col-span-1">
                            <div className="kr-selectform required">
                              <label className="kr-form-label">
                                Processor Generation
                              </label>
                              <div className="kr-selectform flex">
                                <Select
                                  searchable={false}
                                  backspaceDelete={false}
                                  placeholder="Select Processor generation"
                                  name="generationId"
                                  values={[selectedValue?.generationId ?? []]}
                                  className={`form-control kr-form-textbox ${dataError?.generationId === false
                                    ? ""
                                    : "dataError"
                                    }`}
                                  options={dropdownOptions?.processorGeneration?.map(
                                    (option) => ({
                                      value: option?.id,
                                      label: option?.generation,
                                    })
                                  )}
                                  onChange={(selectedOption) =>
                                    handleInputChange(
                                      selectedOption,
                                      "generationId"
                                    )
                                  }
                                />
                                {/* <button
                                  type="button"
                                  className=" btn-primary rounded !rounded-tl-none !rounded-bl-none flex items-center justify-center w-[46px]"
                                  onClick={() =>
                                    showModal("Processor Generation")
                                  }
                                >
                                  <svg
                                    width={10}
                                    className="svg-white"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 34.81 34.81"
                                  >
                                    <g>
                                      <path d="M17.41,0C16.14,0,15.12,1.03,15.12,2.29V15.12H2.29c-1.26,0-2.29,1.03-2.29,2.29s1.03,2.29,2.29,2.29H15.12v12.83c0,1.26,1.03,2.29,2.29,2.29s2.29-1.03,2.29-2.29v-12.83h12.83c1.26,0,2.29-1.03,2.29-2.29s-1.03-2.29-2.29-2.29h-12.83V2.29c0-1.26-1.03-2.29-2.29-2.29h0Z"></path>
                                    </g>
                                  </svg>
                                </button> */}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                    ""
                  ) : (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">Generation</label>
                        <input
                          type="text"
                          placeholder="Enter Generation"
                          maxLength={10}
                          value={selectedValue?.generation?.label}
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.generation === false ? "" : "dataError"
                            }`}
                          onChange={(e) => handleInputChange(e, "generation")}
                        ></input>
                      </div>
                    </div>
                  )}
                  {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                    ""
                  ) : (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">Storage Type</label>
                        <Select
                          searchable={false}
                          backspaceDelete={false}
                          placeholder="Enter Storage type"
                          name="StorageType"
                          values={[selectedValue?.storageType]}
                          className={`form-control kr-form-textbox ${dataError.storageType === false ? "" : "dataError"
                            }`}
                          options={[
                            { value: "HDD", label: "HDD" },
                            { value: "SSD", label: "SSD" },
                          ]}
                          onChange={(selectedOption) =>
                            handleInputChange(selectedOption, "storageType")
                          }
                        />
                      </div>
                    </div>
                  )}
                  {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                    ""
                  ) : (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">Storage Size (GB)</label>
                        <input
                          type="text"
                          placeholder="Enter Storage Size"
                          maxLength={4}
                          value={selectedValue?.storageSize?.label}
                          className={`form-control kr-form-textbox placeholder-[#212529] ${dataError.storageSize === false ? "" : "dataError"
                            }`}
                          onChange={(e) => handlePositiveIntegerChange(e, "storageSize")}
                        ></input>
                      </div>
                    </div>
                  )}

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Purchase Date</label>
                      <input
                        min="2001-01"
                        //max={`${new Date().toISOString().slice(0, 7)}`}
                        max={getTodayDateString()}
                        type="date"
                        placeholder="Purchase Date"
                        name="PurchaseDate"
                        value={selectedValue?.purchaseDate?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] ${dataError?.purchaseDate === false ? "" : "dataError"
                          }`}
                        onChange={(e) => handleInputChange(e, "purchaseDate")}
                        onKeyDown={(e) => e.preventDefault()}
                      ></input>
                    </div>
                  </div>

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Warranty</label>
                      <Select
                        searchable={false}
                        backspaceDelete={false}
                        placeholder="Select Warranty"
                        name="isWarrantyTill"
                        values={[selectedValue?.isWarrantyTill]}
                        className={`form-control kr-form-textbox ${dataError?.isWarrantyTill === false ? "" : "dataError"
                          }`}
                        options={[
                          { value: true, label: "Active" },
                          { value: false, label: "In Active" },
                        ]}
                        onChange={(selectedOption) => {
                          handleInputChange(selectedOption, "isWarrantyTill");
                        }}
                      />
                    </div>
                  </div>

                  {inputValues?.isWarrantyTill === true ? (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">Warranty Till</label>
                        <input
                          min={getTomorrowDateString()}
                          type="date"
                          placeholder="Warranty Till"
                          name="Warrantytill"
                          value={selectedValue?.warrantyTill?.label || ""}
                          className={`form-control kr-form-textbox placeholder-[#212529]`}
                          onChange={(e) => handleInputChange(e, "warrantyTill")}
                          onKeyDown={(e) => e.preventDefault()}
                        ></input>
                      </div>
                    </div>
                  ) : null}

                  <div
                    className={`col-span-2 md:col-span-1 ${currentAsset === "Desktop" || currentAsset === "Laptop" || currentAsset === "RentalLaptop"
                      ? ""
                      : "hidden"
                      }`}
                  >
                    <div className="kr-selectform required">
                      <label className="kr-form-label">OS Type</label>
                      <Select
                        searchable={false}
                        backspaceDelete={false}
                        placeholder="Select OS Type"
                        name="windowsOS"
                        values={[selectedValue?.windowsOS]}
                        className={`form-control kr-form-textbox ${dataError.windowsOS === false ? "" : "dataError"
                          }`}
                        options={[
                          { value: "Windows", label: "WINDOWS" },
                          { value: "Linux", label: "LINUX" },
                          { value: "Mac Os", label: "MAC OS" },
                        ]}
                        onChange={(selectedOption) => {
                          setSelectedValue((option) => ({
                            ...option,
                            isLicensed: {
                              value: null,
                              label:
                                selectedOption[0].value === "Linux"
                                  ? "License type"
                                  : "Licensed/Not",
                            },
                          }));

                          if (selectedOption[0].value === "Mac Os") {
                            setInputValues((input) => ({
                              ...input,
                              isLicensed: true,
                              windowsLicense: null,
                            }));
                          }

                          handleInputChange(selectedOption, "windowsOS");
                        }}
                      />
                    </div>
                  </div>
                  {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                    ""
                  ) : (
                    <div
                      className={`col-span-2 md:col-span-1 ${selectedValue?.windowsOS.value === "Mac Os"
                        ? "hidden"
                        : ""
                        }`}
                    >
                      <div className="kr-selectform">
                        <label className="kr-form-label">
                          {inputValues.windowsOS === "Mac Os" ||
                            inputValues.windowsOS === "Windows" ||
                            inputValues.windowsOS === undefined ||
                            inputValues.windowsOS === null ||
                            inputValues.windowsOS === ""
                            ? "Licensed/Not"
                            : "License Type"}
                        </label>
                        <Select
                          searchable={false}
                          backspaceDelete={false}
                          placeholder={
                            inputValues.windowsOS === "Mac Os" ||
                              inputValues.windowsOS === "Windows" ||
                              inputValues.windowsOS === undefined ||
                              inputValues.windowsOS === null ||
                              ""
                              ? "Licensed/Not"
                              : "License Type"
                          }
                          name="Islicensed"
                          values={[selectedValue?.isLicensed]}
                          className={`form-control kr-form-textbox`}
                          options={
                            inputValues.windowsOS === "Linux"
                              ? [
                                { value: true, label: "Paid Version" },
                                { value: false, label: "Free Version" },
                              ]
                              : [
                                { value: true, label: "Yes" },
                                { value: false, label: "No" },
                              ]
                          }
                          onChange={(selectedOption) => {
                            handleInputChange(selectedOption, "isLicensed");

                            if (selectedOption[0].value === false) {
                              setInputValues((prevInputValues) => ({
                                ...prevInputValues,
                                windowsLicense: null,
                              }));
                            }
                          }}
                          disabled={selectedValue?.windowsOS.value === "Mac Os"}
                        />
                      </div>
                    </div>
                  )}

                  {currentAsset === "Monitor" ? (
                    ""
                  ) : inputValues?.isLicensed === true ? (
                    <div
                      className={`col-span-2 md:col-span-1 !hidden ${inputValues.windowsOS === "Mac Os" ? "hidden" : ""
                        }`}
                    >
                      <div className="kr-selectform">
                        <label className="kr-form-label">
                          {inputValues.windowsOS === "Linux"
                            ? "Linux License"
                            : inputValues.windowsOS === "Mac Os"
                              ? "Mac License"
                              : "Windows License"}
                        </label>
                        <input
                          type="text"
                          placeholder={
                            inputValues.windowsOS === "Linux"
                              ? "Linux License"
                              : inputValues.windowsOS === "Mac Os"
                                ? "Mac License"
                                : "Windows License"
                          }
                          name="Windowslicense"
                          value={selectedValue?.windowsLicense?.label}
                          className={`form-control kr-form-textbox placeholder-[#212529]`}
                          onChange={(e) =>
                            handleInputChange(e, "windowsLicense")
                          }
                        ></input>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* <div className="col-span-2 md:col-span-1">
                  <div className="kr-selectform required">
                    <label className="kr-form-label">Is Active</label>
                    <Select
                      searchable={false}
                      backspaceDelete={false}
                      placeholder="Is Active"
                      name="Isactive"
                      values={[selectedValue?.isActive]}
                      className={`form-control kr-form-textbox ${
                        dataError.isActive === false ? "" : "dataError"
                      }`}
                      options={[
                        { value: true, label: "Yes" },
                        { value: false, label: "No" },
                      ]}
                      onChange={(selectedOption) =>
                        handleInputChange(selectedOption, "isActive")
                      }
                    />
                  </div>
                </div> */}

                  {/* <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform">
                      <label className="kr-form-label">Created By</label>
                      <input
                        type="text"
                        placeholder="Created By"
                        name="Createdby"
                        value={selectedValue?.createdBy?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] 
                     
                        `}
                        onChange={(e) => handleInputChange(e, "createdBy")}
                        readOnly={sidebarAction === "edit"}
                      ></input>
                    </div>
                  </div> */}

                  {/* <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform ">
                      <label className="kr-form-label">Created On</label>
                      <input
                        type="text"
                        placeholder="Created On"
                        name="Createdon"
                        value={new Date().toISOString().substr(0, 10)}
                        className={`form-control kr-form-textbox placeholder-[#212529] 
                      
                      `}
                        onChange={(e) => handleInputChange(e, "createdOn")}
                        readOnly
                      ></input>
                    </div>
                  </div> */}

                  {/* {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                  ""
                ) : (
                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">Is Monitor</label>
                      <Select
                        searchable={false}
                        backspaceDelete={false}
                        placeholder="Is Monitor"
                        name="Ismonitor"
                        values={[selectedValue?.isMonitor]}
                        className={`form-control kr-form-textbox ${
                          dataError.isMonitor === false ? "" : "dataError"
                        }`}
                        options={[
                          { value: true, label: "Yes" },
                          { value: false, label: "No" },
                        ]}
                        onChange={(selectedOption) =>
                          handleInputChange(selectedOption, "isMonitor")
                        }
                      />
                    </div>
                  </div>
                )} */}

                  {/* {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                    ""
                  ) : ( */}
                  {/* //   <div className="col-span-2 md:col-span-1">
                  //     <div className="kr-selectform required">
                  //       <label className="kr-form-label"> Keyboard</label>
                  //       <Select
                  //         searchable={false}
                  //         backspaceDelete={false}
                  //         placeholder="Keyboard"
                  //         name="Iskeyboard"
                  //         values={[selectedValue?.isKeyboard]}
                  //         className={`form-control kr-form-textbox ${dataError.isKeyboard === false ? "" : "dataError"
                  //           }`}
                  //         options={[
                  //           { value: true, label: "Yes" },
                  //           { value: false, label: "No" },
                  //         ]}
                  //         onChange={(selectedOption) =>
                  //           handleInputChange(selectedOption, "isKeyboard")
                  //         }
                  //       />
                  //     </div>
                  //   </div>
                  // )} */}

                  {/* {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                    ""
                  ) : (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">Mouse</label>
                        <Select
                          searchable={false}
                          backspaceDelete={false}
                          placeholder="Mouse"
                          name="Ismouse"
                          values={[selectedValue?.isMouse]}
                          className={`form-control kr-form-textbox ${dataError.isMouse === false ? "" : "dataError"
                            }`}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={(selectedOption) =>
                            handleInputChange(selectedOption, "isMouse")
                          }
                        />
                      </div>
                    </div>
                  )} */}

                  {/* {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                    ""
                  ) : (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label"> Headset</label>
                        <Select
                          searchable={false}
                          backspaceDelete={false}
                          placeholder="Headset"
                          name="Isheadset"
                          values={[selectedValue?.isHeadSet]}
                          className={`form-control kr-form-textbox ${dataError.isHeadSet === false ? "" : "dataError"
                            }`}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={(selectedOption) =>
                            handleInputChange(selectedOption, "isHeadSet")
                          }
                        />
                      </div>
                    </div>
                  )} */}

                  {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                    ""
                  ) : (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform required">
                        <label className="kr-form-label">AV Installed</label>
                        <Select
                          searchable={false}
                          backspaceDelete={false}
                          placeholder="Select AV Installed"
                          name="Isavinstalled"
                          values={[selectedValue?.isAVInstalled]}
                          className={`form-control kr-form-textbox ${dataError.isAVInstalled === false ? "" : "dataError"
                            }`}
                          options={[
                            { value: true, label: "Yes" },
                            { value: false, label: "No" },
                          ]}
                          onChange={(selectedOption) =>
                            handleInputChange(selectedOption, "isAVInstalled")
                          }
                        />
                      </div>
                    </div>
                  )}

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform required">
                      <label className="kr-form-label">State</label>
                      <Select
                        searchable={false}
                        backspaceDelete={false}
                        placeholder="Select State"
                        name="State"
                        values={[selectedValue?.isActive]}
                        className={`form-control kr-form-textbox ${dataError.isActive === false ? "" : "dataError"
                          }`}
                        options={[
                          { value: true, label: "Active" },
                          { value: false, label: "In Active" },

                        ]}
                        onChange={(selectedOption) =>
                          handleInputChange(selectedOption, "isActive")
                        }
                      />
                    </div>
                  </div>

                  {currentAsset === "Webcam" || currentAsset === "Monitor" ? (
                    ""
                  ) : (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform">
                        <label className="kr-form-label">IP Address</label>
                        <input
                          type="text"
                          placeholder="Enter Ip Address"
                          name="Ipaddress"
                          maxLength={50}
                          value={selectedValue?.ipAddress?.label}
                          className={`form-control kr-form-textbox placeholder-[#212529]`}
                          onChange={(e) => handleInputChange(e, "ipAddress")}
                        ></input>
                      </div>
                    </div>
                  )}

                  <div className="col-span-2 md:col-span-1">
                    <div className="kr-selectform">
                      <label className="kr-form-label">Remarks</label>
                      <input
                        type="text"
                        placeholder="Enter Remarks"
                        name="Remarks"
                        maxLength={250}
                        value={selectedValue?.remarks?.label}
                        className={`form-control kr-form-textbox placeholder-[#212529] 
                 
                      `}
                        onChange={(e) => handleInputChange(e, "remarks")}
                      ></input>
                    </div>
                  </div>
                  {/* {currentAsset === "Laptop" && (
                    <div className="col-span-2 md:col-span-1">
                      <div className="kr-selectform flex items-center gap-2 mt-2">
                        <input
                          type="checkbox"
                          id="isRental"
                          checked={inputValues?.isRental === "Yes"}
                          onChange={handleRentalChange}
                          className="w-4 h-4 cursor-pointer accent-orange-500"
                        />
                        <label htmlFor="isRental" className="kr-form-label mb-0 cursor-pointer">
                          Rental
                        </label>
                      </div>
                    </div>
                  )} */}

                  <div className="col-span-2">
                    <div className="kr-selectform flex justify-end">
                      {/* <Link to ='/' className='no-underline'> */}
                      <button
                        type="button"
                        className="flex items-center justify-center py-[6px] px-[12px] btn-light border border-solid border-gray-200 rounded min-w-80"
                        onClick={handleSidebarClose}
                      >
                        Cancel
                      </button>
                      {/* </Link> */}
                      {/* <Link to ='/' className='no-underline'> */}
                      <button
                        type="button"
                        className="btn btn-primary flex items-center justify-center ml-2 min-w-80"
                        onClick={handleSidebarFormSubmit}
                      >
                        {sidebarAction === "add" ? "Add" : "Update"}
                      </button>
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

    </>
  );
}

export default AssetManagement;
